export default {
  SENDING: "Sending...",
  NOTHING_TO_SHOW: "Nothing to show",
  NO_ELEMENTS_FOUND: "No elements found. Please refine your search terms.",
  VALUE_ADDED: "Value added process",
  NOT_VALUE_ADDED: "Other process",
  VIDEO_HOVER: "Watch video",
  BACK: "Back",
  CLOSE: "Close",
  CANCEL: "Cancel",
  YES: "Yes",
  ABORT: "Abort",
  REFRESH: "Refresh",
  RESTORE: "Restore",
  ARCHIVE: "Archive",
  CONFIRM: "Confirm",
  NEXT: "Next",
  VACATION: "Vacation",
  SETTINGS: "Settings",
  SEARCH: "Search",
  PROJECT: "Project",
  CLIENT: "Client",
  CLIENTS: "Clients",
  CLIENTS_GROUPS: "Client groups",
  INTERRUPT_SIDEBAR: "Interrupts",
  USERS_SIDEBAR: "Users",
  PROFIT_CENTERS_SIDEBAR: "Profit centers",
  REPORTS_SIDEBAR: "Reports",
  API_SIDEBAR: "API keys",
  LICENSE_AGREEMENTS_SIDEBAR: "License agreements",
  SERVICE_LINE: "Service line",
  PROCESS_GROUP: "Process Group",
  PROCESS_GROUPS: "Process Groups",
  ALL: "All",
  SELECT_ALL: "Select all",
  PROCESS: "Process",
  INTERRUPT: "Interruption",
  INTERRUPTION: "Interruption",
  INTERRUPTIONS: "Interruptions",
  ACTIONS: "Actions",
  ADD: "Add",
  SAVE: "Save",
  SAVING: "Saving...",
  SAVING_ERROR: "Cannot save. Check the data!",
  STARTED: "Started",
  RETRY: "Retry",
  FINISHED: "Finished",
  ERROR: "Error",
  FILTER: "Filter",
  FILTERS: "Filters",
  ERROR_DATA: "Error: ",
  ERROR_STATUS: "Error code: ",
  INVALID_TIME_FORMAT: "Invalid format. Proper: HH:MM:SS/X.X/Y,Y",
  INVALID_START_TIME_FORMAT: "Invalid format. Proper: HH:MM:SS",
  WORKLOG_OVERLAP_ERROR: "This worklog overlap with another one",
  NAME: "Name",
  AT: "at",
  FROM: "from",
  FOR_DATE: "for",
  TO_DATE: "to",
  OR: "or",
  NA: "N/A",
  REQUIRED: "This field is required",
  LOADING: "Loading...",
  ERROR_LOADING_DATA: "Error loading data — try refreshing the page.",
  PRINT: "Print",
  SUBMIT: "Submit",
  OK: "OK",
  UPDATE: "Update",
  UPDATE_ALL: "Update all",
  DELETE: "Delete",
  RESUME: "Resume",
  TOGGLE_BACKGROUND: "Toggle background color",
  ADMIN: "Admin",
  MANAGER: "Manager",
  CONNECTION_ERROR: "Problems with connection. Check the status of your internet connection.",
  OFFER_CALCULATOR: "Offer calculator",
  SUM: "Sum",
  MONTH_BY_MONTH: "Month by Month",
  SELECTED_TIME_RANGE: "Selected time range:",
  CHANGE: "Change",
  APPLY: "Apply",
  CLEAR: "Clear",
  VIEW: "View",
  EDIT: "Edit",
  CONNECTION_TOO_SLOW: "Your connection is too slow. Please check your internet connection.",
  MONTHS: {
    JANUARY: "01 - January",
    FEBRUARY: "02 - February",
    MARCH: "03 - March",
    APRIL: "04 - April",
    MAY: "05 - May",
    JUNE: "06 - June",
    JULY: "07 - July",
    AUGUST: "08 - August",
    SEPTEMBER: "09 - September",
    OCTOBER: "10 - October",
    NOVEMBER: "11 - November",
    DECEMBER: "12 - December",
    JAN: "Jan",
    FEB: "Feb",
    MAR: "Mar",
    APR: "Apr",
    MAY_SHORT: "May",
    JUN: "Jun",
    JUL: "Jul",
    AUG: "Aug",
    SEP: "Sep",
    OCT: "Oct",
    NOV: "Nov",
    DEC: "Dec"
  },
  WEEK: "Week",
  WEEK_OF: "Week of",
  VA: {
    TRUE: "VA",
    FALSE: "NVA"
  },
  I18N: {
    LANGUAGES: "Languages",
    SWITCH_TO_ENGLISH: "Switch to English",
    SWITCH_TO_GERMAN: "Umschalten auf Deutsch"
  },
  TERMS_OF_USE: {
    TITLE: "Terms of use",
    ACCEPT: "Accept terms of use",
    EN: "English",
    PL: "Polski",
    DE: "Deutsche",
    VERSION: "v.",
    ERROR: "Something went wrong! Please check your internet connection and try again. If problem still exist contact administrator."
  },
  DOCUMENTATION: {
    TITLE: "Documentation center"
  },
  WORKLOG_VALIDATION_ERRORS: {
    DOESNOTSTARTANDENDINDIFFERENTPROCESS: "Ends in next process",
    HASNOPROCESSINSIDE: "Has process inside",
    DOESNOTSTARTORENDININTERRUPT: "Starts or ends in interruption",
    ENDSBEFORESTART: "Ends earlier than it starts",
    DOESNOTSTARTORENDINPROCESS: "Starts or ends inside other process",
    NOTENDSINTHEFUTURE: "Ends in the future",
    ISVALIDSTARTFORMAT: "Start time not valid",
    ISVALIDENDFORMAT: "End time not valid",
    VOLUME: "Volume must be >= 0"
  },
  WORK_DATA: {
    WORK_DATA: "Employee view",
    EXPORT: "Export",
    EXPORT_DATA: "Export Data",
    BACK_TO_REPORTING: "Back to reporting",
    SELECTED_DATES: "Pick date",
    SELECTED_DAY: "Pick a day",
    SELECT_DATE_PLACEHOLDER: "Pick a date",
    FROM: "from",
    TO: "to",
    DURATION: "Duration",
    DURATION_WITH_INVOICED_TIME: "Duration / Invoiced time",
    VOLUME: "Vol.",
    SAVE: "Save",
    VOLUME_LONG: "Volume",
    VA: "Value added",
    ADDED_MANUALLY: "Added man.",
    ADDED_MANUALLY_LONG: "Added manually",
    COMMENT: "Comment",
    INVOICE_DETAILS: "Invoice details",
    REPORTED_TIME: "Reported time:",
    WORKNORM: "Worknorm:",
    STATS: "Stats",
    HOLIDAY: "Holiday",
    TIME_TODAY: "Time today:",
    TIME: "Time:",
    REPORTED_TIME_PERCENT: "Reported time ratio: ",
    PROCESS_GROUPS_AND_INTERRUPTS: "Process groups and interruptions",
    REPORTED_OVERTIME: "Reported overtime",
    ACCEPTED_OVERTIME: "Accepted overtime",
    CUMULATED_OVERTIME: "Over(-Under) time balance",
    USED_OVERTIME: "Used overtime:",
    REPORTED_REQUEST_OVERTIME: "Reported request overtime:",
    UNSAVED_DATA_CHANGE_DATE_CONFIRMATION: "You haven't save changes. Are you sure you want to change dates?",
    TO_ACCEPT: "To accept",
    ACCEPTED: "Accepted",
    TEAM_LEADER_VIEW: "Team leader view",
    FILTER_USERS: "Filter users",
    FILTERS: "Filter(s)",
    USERS: "Users",
    D365_STATUSES: "D365 statuses",
    ACCEPT: "Accept",
    ACCEPT_ALL: "Accept all",
    EDIT: "Edit",
    DECLINE: "Delete",
    DECLINE_OVERTIME: "Decline",
    ADD_NEW_WORKLOG: "Add new worklog",
    SELECT_WORKLOG_TYPE: "Select worklog type:",
    SELECT_INTERRUPT: "Select interruption:",
    WORKLOG_TYPE: "Worklog type:",
    SELECT_PROCESS: "Select process:",
    START_DATE: "Date",
    START_TIME: "Start time",
    END_TIME: "Finish time",
    FINISH_TIME: "Finish time",
    OVERLAP_ERROR: "Cannot save. Check the time. Ensure that processes time do not overlap and all interruptions overlap with no more than one process.",
    VACATION_ERROR: "Cannot save. Check the dates. Ensure that the 'From' date is less or equal 'To' date and that 'From' date is not in the past.",
    VACATION_SUCCESS: "You have successfully reported vacation.",
    VACATION_DELETED: "You have deleted vacation",
    DELETE_CONFIRMATION: "Are you sure you want to delete this work entry?",
    LOT_OF_DATA: "There could be a lot of data to display.",
    LOT_OF_DATA_ACTION: "Show the data",
    SELECT_ALL: "Select all",
    GO_TO_DATE: "Go to date",
    NAME: "Name",
    DATE: "Date",
    PROCESS: "Process",
    TOTAL_ROWS: "Total rows",
    PROJECT: "Project",
    NO_PROJECT: "No project",
    SELECT_COLUMNS: "Select columns",
    COLUMNS: "Columns",
    TOGGLE_INACTIVITY_PERIODS: "Inactivity",
    MANAGEMENT_MODE: "Mgmt. mode",
    SYNCHRONIZE_WORKLOGS_STATUSES: "Synchronize worklogs statuses",
    RESEND: "Resend",
    INVOICED_TIME: "Invoiced time",
    D365_STATUS: {
      SENT: "D365 - Sent",
      ERROR: "D365 - Sent but failed. Contact with support team",
      PROCESSED: "D365 - Processed",
      PROCESSED_TO_KCP: "D365 - Processed to KCP",
      SENDING_ERROR: "D365 - Sending error",
      AFTER_ACCEPT_SENT_SUCCESS: "Worklog accepted and sent to D365",
      AFTER_ACCEPT_SENT_SUCCESS_BUT_PROCESS_ERROR: "Worklog accepted and sent to D365 but processing error occurred",
      AFTER_ACCEPT_SENT_FAIL: "Worklog accepted but not sent to D365",
      AFTER_ACCEPT_SENT_FAIL_NO_MATCHING: "Worklog accepted but not sent to D365 due to matching issues",
      PROCESS_ERROR: "D365 - Process matching not found",
      PROJECT_ERROR: "D365 - Project not found",
      NO_D365_STATUS: "No D365 status",
      DELETED: "D365 - Deleted"
    },
    VACATION: {
      VACATION: "Vacation",
      REPORT_VACATION: "Report vacation",
      REPORTED_VACATION: "Reported vacation:",
      FROM: "From",
      TO: "To",
      PROCESS_NAME: "Process name",
      PROJECT_NAME: "Project name",
      NAME: "Name",
      FROM_PLACEHOLDER: "2018-12-24",
      FROM_TOOLTIP: "The 'From' date must be less or equal 'To' date. 'From' date must not be in the past.",
      TO_TOOLTIP: "The 'From' date must be less or equal 'To' date.",
      DELETE_VACATION: "Delete vacation",
      INVALID_DATE_FROM: "FROM must be after today",
      INVALID_DATE_TO: "TO must be after today and before FROM",
      MISSING_DATE_FROM: "FROM cannot be empty",
      MISSING_DATE_TO:"TO cannot be empty",
      PICK_THE_HOUR:"Select hours",
      PICK_THE_PERCENTAGE:"Select percentage",
      SET_PERCENTAGES:"Set percentage:",
      FULL_TIME:"Full-time",
      FULL_TIME_VACATION:"Full-time vacation",
      PART_TIME_VACATION:"Part-time Vacation",
      ERROR: "Some days were not added due to 0 worknorm",
      SET_HOURS: "Set hours by day:"
    },
    VACATION_NOTES: {
      ALL_ZERO_WORKNORM: "All selected days had a worknorm of 0",
      OMITTING_HOLIDAYS: "Omitted some holidays while adding vacations in the selected date range",
      WRONG_DATE: "The 'from' date must be less or equal 'to' date and 'from' date must not be in the past",
      VACATIONS_EXIST_IN_RANGE: "Vacations in the specified range already exist",
      WORKLOG_VALIDATION_FAILED: "You have already reported today",
      PROCESS_NOT_FOUND: "The process is not a vacation process or no process exists at all",
      PROCESS_CONFIG_NOT_FOUND: "Such process configuration does not exist",
      CLIENT_NOT_FOUND: "There is no such client",
      ALL_DAYS_ARE_HOLIDAYS: "All selected days are holidays",
      NO_FEATURE_FLAG: "VacationReporting feature flag is not set for the user's country",
      DAYS_WITH_EXCEEDED_TIME_1: "Available time range in ",
      DAYS_WITH_EXCEEDED_TIME_2: " (from last worklog until midnight) was exceeded. Please, delete worklogs and try again."
    },
    POWER_USER: {
      IS_POWER_USER_TRUE: "You are a Power User!",
      IS_POWER_USER_FALSE: "You are not a Power User yet.",
      LONG_TERM_USER_INFO: "You need to achieve 120 days with 95% of the reported time ratio in order to be eligible for the Power User status.",
      LONG_TERM_USER_REPORTED: "You reported",
      LONG_TERM_USER_REPORTED_OVER: "You reported over",
      LONG_TERM_USER_DAYS: "days",
      LONG_TERM_USER_CHECK: "Check your days-streak and Power User status.",
      DAYS_STREAK_TRUE: "You have a streak! Keep going to become a Power User!",
      DAYS_STREAK_FALSE: "Sorry, you have lost your streak.",
      MORE_DAYS_TO_GO: "more days to go!",
      POWER_USER_REFRESH_FAIL: "You do not meet the criteria for the Power User yet.",
      POWER_USER_REFRESH_GRANTED: "You are now the Power User."
    },
    TOOLTIP: {
      REFRESH: "Update Power User status",
      TIME: "Total time of processes reported",
      TIME_TODAY: "Time today spent in KliX from the start of the first process until now",
      RATIO: "The ratio of reported time divided by time",
      REPORTED: "Reported overtime hours. This is the time that exceeds the worknorm",
      ACCEPTED: "Overtime hours accepted by a team leader",
      BALANCE: "Overtime or Undertime balance from 01 January till 31 December of given year"
    },
    USER: "User",
    DISPLAY_PREFERENCES: {
      TITLE: "Display preferences",
      MANAGEMENT_LEVEL: "Management level",
      TEAM_LEADER_LEVEL: "Team Leader level",
      DEPUTY_TEAM_LEADER_LEVEL: "Deputy Team Leader level",
      EMPLOYEE_LEVEL: "Employee level",
      SHOW_DATA: "Show data",
      EXCLUDED_FROM_PROFITABILITY_VIEW: "(Excluded from Profitability View)"
    },
    SPLIT_MODAL: {
      DESCRIPTION: "Reported time exceeds the overall time for the request. Do you want to split the reported time into a request and a normal worklog?",
      NO_DESCRIPTION: 'If you choose "No", you have to edit this worklog before save.',
      YES: "Yes",
      NO: "No"
    },
    APPLICATION_OVERTIME: "Overtime request"
  },
  STATS: {
    CLIENTS: "Clients",
    CLIENT_NAME: "Client",
    CLIENT_GROUP: "Group",
    CLIENT_GROUPS: "Client groups",
    TYPE_CLIENT_NAME: "Type name of client's company...",
    TYPE_CLIENT_GROUP: "Type name of client's group...",
    TYPE_EMPLOYEE_NAME: "Type employee name...",
    TYPE_TEAM_NAME: "Type team name...",
    VA_TO_NVA: "VA/NVA",
    TIME: "Time",
    HOURLY_RATE: "hourly",
    PROFITABILITY_RATE: "profitability",
    CURRENCY: "Currency",
    AVAREGE_HOURLY_RATE: "~HR",
    CHECKED: "Checked",
    DELETED: "Deleted",
    FULL_NAME: "Full name",
    REPORTED_TIME: "Reported",
    UNREPORTED_TIME: "Unreported",
    INTERRUPTERS: "Interrupters",
    REPORT: "Report",
    GENERATED_AT: "generated at",
    GENERATED_BY: "by",
    FREQUENCY: "Frequency",
    EXPORT_REPORT: "Export report",

    INTERNAL_TIME: "Internal Time",
    TURNOVER: "Total turnover",

    SET_TARGETS: "Set Targets",

    TEAM_DASHBOARD: "Dashboard",
    PROBLEMS: "Process problems",
    INACTIVITY_PERIODS: "Inactivity periods",
    PROCESS_GROUPS: "Top ten clients",
    TOP_TEN_CLIENTS: "Top ten clients",
    TOP_TEN_PROCESSES: "Top ten processes",
    DAILY_REPORT: "Daily report",
    PROFITABILITY_VIEW: "Profitability view",
    PROFITABILITY_REPORT: "Profitability view",
    DETAILED_VIEW: "Detailed view",
    AVERAGE_HOURLY_RATE: "Average hourly rate",
    EFFECTIVE_HOURLY_RATE: "Effective hourly rate",
    PERCENT_OF_REPORTED_TIME: "% of reported time",
    PERCENT_OF_VA_ACTIVITIES: "% of VA processes",
    PERCENTAGE_OF_TIME_REPORTED_MONTHLY: "Time reported monthly",
    PERCENTAGE_OF_OPPORTUNITY_TIME: "Opportunity time",
    PERCENTAGE_OF_OPPORTUNITY_TIME_NOT_ROEDL: "Invested time",
    PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED: "Worklog entries accepted",
    PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED: "Worklog entries added manually",
    ACCEPTED_OVERTIME_FOR_WHOLE_TEAM: "Accepted overtime",
    ACCEPTED_OVERTIME: "Accepted overtime",
    REPORTED_OVERTIME: "Reported overtime",
    CUMULATED_OVERTIME: "Over(-Under) time balance",
    REMAINING_OVERTIME: "Over(-Under) time balance",
    TOTAL_OVERTIME: "Total overtime",
    EMPLOYEES: "Employees",
    OVERTIME: "Overtime",
    UNDERTIME: "Undertime",
    NO_OVERTIME: "No overtime",
    OTHER: "Other",
    DATA_QUALITY: "Quality",
    PROFITABILITY: "Profitability",
    AVERAGE: "Average rate",
    EFFECTIVE: "Effective rate",
    AVERAGE_PROFITABILITY_RATE: "Average profitability rate",
    EFFECTIVE_PROFITABILITY_RATE: "Effective profitability rate",
    AVERAGE_PROFITABILITY_TREND_CHART: "Average profitability",
    BACK_TO_TL_VIEW: "Back",
    TIME_SPENT: "Time spent",
    VA_PERCENT: "VA%",
    MAIN_EMPLOYEE: "Main employee",
    EMPLOYEE: "Employee",
    NR_OF_PROCESS_PROBLEMS: "Nr of process problems",
    H_TEAM: "team",
    H_TEAMS: "teams",
    H_NO_TEAM: "no team",
    TEAMS: "Teams",
    TEAM_NAME: "Team name",
    MAIN_TEAM: "Main team",
    CHOOSE_TEAM: "Pick teams",
    SELECT_ALL: "Select all",
    CURRENTLY_IN_ANOTHER_TEAM: "Currently not in this team",
    CURRENTLY_IN_LONG_TERM_VIEW: "Currently is on long term leave",
    CURRENTLY_BLOCKED: "User deleted",
    DURATION_OVER_DAYTIME: "Duration overlap to next day",
    START_TIME_IS_NOT_BEFORE_ALL_WORKLOGS: "Start time has to be before all previous worklogs",
    OVERTIME_REQUEST_ALREADY_ALLOCATED_ERROR: "Overtime request is already allocated",
    ARCHIVED_AT: "arch:",
    NO_SITES: "no sites",
    NO_PROFIT_CENTER: "no profit center",
    NO_PROFIT_CENTERS: "no profit centers",
    VA: "VA",
    NVA: "NVA",
    EUR: "EUR",
    SELECTED: "selected",
    NO_EMPLOYEES: "No employees in this team",
    PROCESSES: "Processes",
    TOTAL_COST: "Total cost",
    TOTAL_MARGIN: "Total margin",
    CLIENT_TIME: "Client time",
    TEAM_COST: "Team cost",
    PROFIT: "Profit",
    PERCENTAGE_WORKLOGS_CHANGED: "Worklog entries added manually",
    TOOLTIP: {
      TURNOVER: "Sum of incomes for given client(s) for selected teams(s) in the selected time range",
      INTERNAL_TIME: "Sum of time (% of total time) reported on internal activities and interrupters not connected with clients",
      PERCENTAGE_OF_TIME_REPORTED_MONTHLY: "Total time registered in KliX divided by time that was expected to be reported based on work norms of respective employees. The indicator cannot exceed 100%",
      PERCENTAGE_OF_OPPORTUNITY_TIME: "Time reported on internal processes representing continuous improvement, business development and trainings divided by total time reported",
      PERCENTAGE_OF_WORKLOG_ENTRIES_ACCEPTED: "Number of worklog entries accepted by Team leader(s) in team leader view divided by the total number of worklogs reported",
      PERCENTAGE_OF_WORKLOG_ENTRIES_CHANGED: "Number of worklogs added manually by team leader or Power User divided by total number of worklogs",
      AVERAGE: "Total income divided by total time reported. This includes internal work, interrupters, holidays and other absences",
      EFFECTIVE: "Total income divided by time reported on client work. This includes all processes and interrupters that was reported in connection to clients",
      PROFITABILITY_RATE: "Hourly rate divided by cost rate. Cost rate of work is calculated considering time reported and the cost rate associated with each employee level performing the work. Employee levels are junior, regular, senior, middle manager and top manager",
      REPORTED_OVERTIME: "Overtime hours reported by employees. This is the time that exceeds their worknorm",
      ACCEPTED_OVERTIME_FOR_WHOLE_TEAM: "Overtime hours reported by employees that were approved by team leaders",
      CUMULATED_OVERTIME: "Overtime or Undertime balance from 01 January till 31 December of given year",
      EMPLOYEE: "Employee name",
      TEAM_NAME: "Official name of the team in the system",
      AVERAGE_HOURLY_RATE: "Total income divided by total time reported for the given team. This includes internal work, interrupters, holidays and other absences",
      AVERAGE_PROFITABILITY_RATE: "Hourly rate divided by cost rate for the given team. Cost rate of work is calculated considering time reported and the cost rate associated with each employee level performing the work. Employee levels are junior, regular, senior, middle manager and top manager",
      CLIENT_GROUP: "Official client group name in the system",
      EFFECTIVE_HOURLY_RATE: "Total income divided by total time reported for the given client group.  This includes all processes and interrupters that were reported in connection to clients",
      EFFECTIVE_PROFITABILITY_RATE: "Hourly rate divided by cost rate for the given client group. Cost rate of work is calculated considering time reported and the cost rate associated with each employee level performing the work. Employee levels are junior, regular, senior, middle manager and top manager",
      TIME_SPENT: "Total time reported on the given client group",
      VA_PERCENT: "Time reported on (VA) Value Added processes divided by total time reported for the given client group",
      MAIN_EMPLOYEE: "Employee that reported most of the time for a given client group",
      MAIN_TEAM: "Team that reported most of the time for a given client group",
      NR_OF_PROCESS_PROBLEMS: "Total number of process problems reported",
      CLIENT_NAME: "Official client name in the system",
      CLIENT_GROUP_BELONGS: "Official client group name in the system to which the client belongs",
      CLIENT_EFFECTIVE_HOURLY_RATE: "Total income divided by total time reported for the given client. This includes all processes and interrupters that were reported in connection to clients",
      CLIENT_EFFECTIVE_PROFITABILITY_RATE: "Hourly rate divided by cost rate for the given client. Cost rate of work is calculated considering time reported and the cost rate associated with each employee level performing the work. Employee levels are junior, regular, senior, middle manager and top manager",
      CLIENT_TIME_SPENT: "Total time reported on the given client",
      CLIENT_VA_PERCENT: "Time reported on (VA) Value Added processes divided by total time reported for the given client",
      CLIENT_MAIN_EMPLOYEE: "Employee that reported most of the time for a given client",
      CLIENT_MAIN_TEAM: "Team that reported most of the time for a given client",
      PERCENTAGE_WORKLOGS_CHANGED_TOOLTIP: "Number of worklogs added manually by team leader or Power User divided by total number of worklogs",
      WORKLOGS: {
        NAME: "Official client name in the system",
        PROJECT: "",
        PROCESS_GROUP: "Official process group name in the system",
        PROCESS: "Official process name in the system",
        DATE: "Date of reported process",
        START_TIME: "Time when a process starts being reported",
        END_TIME: "Time when a process stops being reported",
        DURATION: "Amount of time spent on a process",
        DURATION_WITH_INVOICED_TIME: "Duration - Amount of time spent on a process. Invoiced time - Amount of time that was invoiced for a process",
        VALUE_ADDED: "Indicates whether a process is VA (paid by the client) or NVA (not paid by the client)",
        VOL: "Number of units (e.g. entry lines, documents) reported for a process",
        ADDED_MAN: "An entry added manually by team leader or Power User",
        COMMENT: "Internal comments reported for a process",
        INVOICE_DETAILS: "Scope of work to be shown in the invoice",
      },
      OVERTIME: {
        COMMENT: "Internal comments",
        OVERTIME_BALANCE: "Overtime or Undertime balance from 01 January till 31 December of given year including allocated overtime from overtime requests",
        BALANCE_PREVIOUS: "Overtime or Undertime balance from previous years",
        DATE: "Date of reported day",
        WORKNORM: "Required amount of time an employee is obliged to report",
        WORK_TYPE: "Time of individual work arrangements (hourly/long term leave/worknorm)",
        WORK_TIME: "Time reported on a selected date",
        REPORTED_OVERTIME: "Overtime hours reported by an employee. This is the time that exceeds the worknorm",
        ACCEPTED_OVERTIME: "Overtime hours accepted by a team leader",
        MODE: "Overtime mode type (manual/auto/disabled)",
        OVERTIME_REQUEST_BALANCE: "Overtime balance from overtime requests from 01 January till 31 December of given year"
      },
      PROFITABILITY: {
        APPLICATION_OVERTIME: "Overtime hours reported by employee on overtime request",
        ALLOCATED_APPLICATION_OVERTIME: "Overtime hours allocated from overtime requests from 01 January till 31 December of given year"
      },
      APPLICATION_OVERTIME: "Overtime hours reported by employee on overtime request on a selected date",
      ALLOCATED_APPLICATION_OVERTIME: "Overtime hours allocated on selected day from chosen overtime request",
      TOTAL_COST: "Sum of multiplied times and rates at employee levels",
      TOTAL_MARGIN: "Total turnover reduced by total cost",
      TIME_FOR_CLIENTS: "Time spent on clients",
      EFFECTIVE_HOURLY_RATE_FOR_TEAM: "Total income divided by total time reported for the given team. This includes all processes and interrupters that were reported in connection to clients",
      EFFECTIVE_PROFITABILITY_RATE_FOR_TEAM: "Hourly rate divided by cost rate for the given team. Cost rate of work is calculated considering time reported and the cost rate associated with each employee level performing the work. Employee levels are junior, regular, senior, middle manager and top manager",
    }
  },
  OVERTIME: {
    DATE: "Date",
    WORKNORM: "Worknorm",
    WORK_TIME: "Work Time",
    TYPE: "Work type",
    TOTAL: "Total",
    OVERTIME: "Overtime",
    REPORTED: "Reported Overtime",
    ACCEPT: "ACCEPTED OVERTIME",
    CUMULATED: "Remaining",
    TOTAL_CUMULATED: "Total remaining",
    OVERTIME_BALANCE: "Over(-Under) time balance",
    UNDERTIME_BALANCE: "Undertime balance",
    STATS: "Worklogs",
    AUTO: "Auto",
    DISABLED: "Disabled",
    MODE: "Mode",
    COMMENT: "Comment",
    MANUAL: "Manual",
    SUM: "Sum",
    ERROR: "Cannot save. Check if the accepted overtime does not exceed the reported one.",
    ERROR_GET: "There is a problem with loading overtimes. Please check status of your internet connection.",
    WAITING: "Waiting",
    ANNUAL_SET_OFFS: "Annual set-offs",
    OVERTIME_BALANCE_PREVIOUS: "Over(-Under) Time Balance from previous years",
    SETTLE: "Settle",
    EV_SETTLE: "View settle",
    CUMULATED_FROM_PREVIOUS_YEARS: "Cumulated from previous years",
    PLACEHOLDER: {COMMENT: "Type a comment..."},
    APPLICATION_OVERTIME: "Overtime request",
    ALLOCATED_APPLICATION_OVERTIME: "Allocated overtime request",
    TOOLTIP : {DISABLED_SETTLEMENT: "This user doesn't have overtime to use"},

    USE_FIFO: "Use (FIFO)",
    RESET_FIFO: "Reset (FIFO)",

    MODAL: {
      DATE: "Date",
      VIEW: "View",
      OVER_TIME_BALANCE: "Over(-under) time balance",
      ACCEPTED_TIME_BALANCE: "Accepted over(-under) time balance",
      WORKLOGS_ACCEPTED: "% worklogs accepted",
      USED_OVERTIMES: "Used overtimes",
      COMMENT: "Comment",
      ACTIONS: "Actions",
      WORKNORM: "Worknorm",
      WORKTIME: "Worktime",
      ACCEPTED_OVERTIME: "Accepted overtime",
      ALREADY_USED: "Already used",
      OVERTIME_TO_USE: "Overtime to use",
      CUMULATED_OVERTIME: "Over(-Under) time balance",
      SETTLED_OVERTIME: "Settled overtime",
      DECLINE: "Delete",
      APPLICATION_OVERTIME: "Overtime request",
      OVER_UNDER_TIME: "Over(Under-) time",
      ALREADY_ALLOCATED: "Already allocated",
      TOOLTIP: {
        DATE: "Year of reported overtime",
        SETTLED_DATE: "Date of reported settlement",
        OVER_TIME_BALANCE: "Overtime or Undertime balance from 01 January till 31 December of given year",
        ACCEPTED_TIME_BALANCE: "Overtime or Undertime balance from 01 January till 31 December of given year accepted by a team leader",
        WORKLOGS_ACCEPTED: "Number of worklog entries accepted by Team leader(s) in team leader view divided by the total number of worklogs reported",
        USED_OVERTIMES: "Amount of overtime used in a given year",
        COMMENT: "Internal comments",
        SETTLED_OVERTIME: "Number of settled overtime",
        WORKNORM: "Required amount of time an employee is obliged to report",
        WORKTIME: "Time reported on a selected date",
        ACCEPTED_OVERTIME: "Overtime hours accepted by a team leader",
        ALREADY_USED: "Amount of overtime already used as settlements",
        OVERTIME_TO_USE: "Enter the amount of overtime you want to use from certain days, on which overtime was reported and accepted",
        APPLICATIONS_OVERTIME_BALANCE: "Overtime balance from overtime requests from 01 January till 31 December of given year",
        APPLICATION_OVERTIME: "Overtime hours reported by employee on overtime requests from 01 January till 31 December of given year"
      },
      DISABLED_FOR_NOT_WORKNORM: "Your work type is not Worknorm. You have to manually enter 'OVERTIME TO USE'.",
      DISABLED_WHEN_COVERED: "'ALREADY ALLOCATED' fully covers 'OVER(UNDER-) TIME'. You have to manually enter 'OVERTIME TO USE'."
    },
    MODAL_SETTLE:{
      CREATE: "Create settlement",
    },
    ALLOCATED_OVERTIME_REQUEST: "Allocated overtime request:",
    APPLICATIONS_OVERTIME_BALANCE: "Overtime request balance:",
    REQUESTS_OVERTIME_BALANCE: "Overtime request balance from previous years:",
    SETTLED_OVERTIME_REQUEST: "Settled overtime request:"
  },
  AUTH: {
    LOGIN_TITLE: "Sign in",
    LOGIN_INFO: "Please provide your credentials to access time tracking system.",
    EMAIL: "Email",
    EMAIL_PLACEHOLDER: "bob@roedl.com",
    EMAIL_PLACEHOLDER_BUNDLE: "Enter your e-mail here...",
    PASSWORD_PLACEHOLDER: "Enter your password here...",
    PASSWORD: "Password",
    CODE: "Code",
    CODE_PLACEHOLDER: "Code",
    EMAIL_CODE: "5 login attempt failed. If your email has been registered in KliX, check your mailbox — you will receive a code that will allow you to enter a new password.",
    RESEND_CODE: "Resend email with code",
    OVERDUE_PASS1: "Your password has been used over a year.",
    OVERDUE_PASS2: "It is time to change it!",
    ENTER_NEW_PASS: "Enter new password here...",
    ENTER_CONFIRM: "Confirm password here...",
    TRY_AGAIN: "Try again",
    FAILED: "Something went wrong!",
    DONE: "Your password has been changed successfully!",
    DONT_USE1: "Please do not use your name, surname and company name.",
    DONT_USE2: "You used words from below in your new password: ",
    LOGIN: "Sign in",
    LOGIN_SSO: "Sign in using Rödl & Partner SSO",
    LOGIN_SSO_ENTERPRISE: "Sign in using SSO",
    SIGNED_IN_AS: "Signed in as",
    FORGOT_PASSWORD: "Forgotten password?",
    ERROR: "Error signing you in.",
    ACCOUNT: "Account",
    LOGOUT: "Logout",
    CHANGE_PASSWORD: "Change password",
    RESET_PASSWORD: "Reset your password",
    RESET_PASSWORD_INFO: "In order to reset your password, enter your email address below. We will send you an email with further instructions.",
    SEND_RESET_PASSWORD_INSTRUCTIONS: "Send",
    SETTING_NEW_PASSWORD: "Setting new password...",
    SENDING_LINK_SUCCESS: "If you entered right address, you should soon get an email with further instructions.",
    SET_NEW_PASSWORD: "Set new password",
    SET_NEW_PASSWORD_INFO: "Please enter your new password. It needs to be at least 8 characters long, one symbol, one uppercase, one lowercase and one digit character. Do not use your name, surname and company name.",
    NEW_PASSWORD: "New Password",
    NEW_PASSWORD_CONFIRMATION: "New Password Confirmation",
    PASSWORDS_DO_NOT_MATCH: "Password and it's confirmation don't match.",
    SENDING_ERROR: "We couldn't send you a reset instructions. Please try again later or contact administration.",
    ERROR_SETTING_PASSWORD: "Error. Be sure to match password criteria.",
    PASSWORD_TOO_SHORT: "Provided password is too short.",
    MIGRATION_TO_KLIX_DOMAIN: "The system is being moved to a new domain klix-web.com. Please click the button on the right to relogin to a new domain.",
    MIGRATION_TO_KLIX_DOMAIN_RELOGIN: "Relogin",
    BPE_VIDEO: "BPE Program explained",
    VIDEO: "Program explained"
  },
  WORK: {
    CLIENTS: "Clients",
    PROCESS_GROUPS: "Process Groups",
    PROCESS: "Process",
    TYPE_CLIENT_NAME: "Type name of client's company...",
    SELECTED_CLIENT: "Client:",
    PROCESS_GROUP: "Process group:",
    SELECT_ANOTHER_CLIENT: "Select another client",
    SELECT_ANOTHER_INTERRUPT: "Select another interruption",
    SELECT_ANOTHER_SERVICE_LINE: "Select another service line",
    PROCESSES: "Choose a process group you're starting work on",
    BACK: "Back to client and process group choice",

    REPORT_FINISH: "Report finishing a process",

    INTERRUPTS: "Report interruption",
    CHOOSE_CLIENT: "Choose client",
    CHOOSE_SERVICE_LINE: "Choose a service line",
    COMMENT: "Additional comment",
    INVOICE_DETAILS: "Invoice details",
    REPORT_INTERRUPTER: "End interruption",
    VA: "VA",

    FINISH_PROCESS: "Finish process",
    REPORT_VOLUME: "Report volume",

    REPORT_PROJECT: "Choose project",

    FINISH_PROCESS_REPORTING_PROBLEM: "Finish and report problem",
    PROBLEM_TYPE: "Choose a problem type",
    CHOOSE_THIS_CLIENT: "Choose",
    ERROR: "Error saving your data",
    ERROR_PROCESS_TOO_LONG: "- marked process started on a different date!",
    ERROR_SENDING: "Please note that we weren't able to process your data entry. Make sure you don't work on multiple browser tabs. If this is not the case, try again or contact administrators.",
    ERROR_VACATION: "You can not report process during your vacation.",
    ERROR_KLIX_CONNECTION: "Reporting failed because we encountered problems with KliX Server.",
    YOU_ARE_ON_VACATION: "You are on vacation.",
    REMOVE_VACATION: "Remove vacation to be able to report your time.",

    VOLUME: "Volume",

    NOTE_FINISH: "You reported finishing process",
    NOTE_INTERRUPTION: "You reported interruption",
    NOTE_REPORTED: "You reported a problem while finishing",
    NOTE_STARTED: "You started working on",
    NOTE_RESUMED: "Resuming",
    CANCEL_CONFIRMATION: "Do you really want to EXIT your process?",
    RESUME_QUESTION: "Do you want to EXIT process you previously started?",
    RESUME_PROCESS: "Resume process",
    RESUME_INTERRUPTION: "Resume interruption",
    EXIT: "Exit the process",
    PROCESS_TOO_LONG: "Process started on a different date - it will be aborted. Always finish your process at the end of the day.",

    OVERTIME_BALANCE: "Overtime balance",
    TODAY_OVERTIME: "Today overtime",
    BAR_TEXT: "Today reported time",
    TIME_TODAY: "Time today",
    ERRORS: {
      PREFERENCES: "We couldn't get your preferences. Try to reload the page or contact administrator.",
      DAILY_STATS: "We couldn't get your daily stats. Try to reload the page or contact administrator."
    },

    HIDDEN_PROCESSES: "Hidden processes",
    HIDE_MESSAGE: "Do you want to hide this process for all the clients or just {{name}}?",
    UNHIDE_MESSAGE: "Do you want to unhide this process?",
    UNHIDE: "Unhide",
    FOR_ALL_CLIENTS: "For all the clients",
    ONLY_FOR_ONE_CLIENT: "Only for",
    NO_PROBLEMS_ARE_DEFINED: "No problems are defined on this process group",
    OVERTIME_APPLICATION: "Overtime request",
    WITH_OVERTIME_APPLICATION: "If you want to send worklog with overtime request, choose some from the list",
    WITHOUT_OVERTIME_APPLICATION: "If not, leave the field blank.",
    CHANGE_FINISH_TIME: "Change finish time",
    MAXIMUM_PROCESS_OFFSET: "Maximum process offset is only possible till the end of the latest interrupt or minute before you opened this window. You can set finish time from {{min}} to {{max}}",
    CHANGED_FINISH_TIME_DISABLED_TOOLTIP: "This option is not available now. You can begin the finishing process at {{min}}",
    FINISH_TIME_POSSIBILITIES: "You can set finish time from {{min}} to {{max}}",
    LOADING_POSSIBLE_FINISH_TIME: "Information about the possible finish time is loaded",
    BILLING_TYPE: "Billing type",
    BILLING_TYPE_TOOLTIP: "Select a billing type for a given client if it is different than the default one",
    CHOOSE_CLIENT_AND_PG: "Choose client and process group",
    CHOOSE_CLIENT_FOR_NEW_PROCESS: "Choose client",
    CHOOSE_PG_FOR_NEW_PROCESS: "Choose process group",
    CHANGE_INVOICING_TIME: "Change Invoicing time",
    REPORTED_TIME: "Reported time",
    TIME_TO_INVOICE: "Time to invoice",
  },
  CHECK_VERSION: {
    NEW: "You are using {{actualVersion}} version of the request. There is a new one {{newVersion}} version. Finish your job and reload this page. (Windows: Ctrl + F5, OSX: ⌘ + R)"
  },
  COUNTRIES: {
    TITLE: "Countries",
    NEW: "Add new country",
    SEARCH: "Type name of a country",
    NAME: "Country name",
    CURRENCY: "Currency code",
    CURRENCY_TOOLTIP: "ISO 4217 standard, e.g. USD, EUR.",
    EDIT: "Edit",
    VIEW: "View",
    NEW_COUNTRY: "New country",
    EDIT_COUNTRY: "Edit country",
    CODE: "Code",
    CODE_TOOLTIP: "ISO 3166-1 Alpha-2 code standard, e.g. US, GB.",
    LEVELS: "Levels",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder"
  },
  FLAGS: {
    TITLE: "Feature Flags",
    SEARCH: "Type name of country",
    EDIT: "Edit",
    NAME: "Country",
    EDIT_FLAGS: "Edit flags"
  },
  INTERRUPTS: {
    TITLE: "Interrupts",
    SEARCH: "Type name of an interrupt",
    NAME: "Interrupt name",
    ADD: "Add new interrupt",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_INTERRUPT: "New interrupt",
    EDIT_INTERRUPT: "Edit interrupt",
    DELETE_INTERRUPT: "Delete interrupt"
  },
  GROUPS: {
    TITLE: "Process groups",
    SEARCH:"Type name of a group",
    NEW: "Add new process group",
    NAME: "Name",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_GROUP: "New process group",
    GROUP_NAME: "Group name",
    EDIT_GROUP: "Edit group",
    DELETE_GROUP: "Delete group",
    VALIDATION_ERROR: "Invalid character(s) in name"
  },
  COUNTRY: {
    TITLE: "Process groups configurations",
    SEARCH: "Type name",
    NEW: "Add new process group configuration",
    NAME: "Local translation",
    DESCRIPTION: "Local description",
    COUNTRY: "Country",
    CANNONICAL_NAME: "Global name",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_CONFIGURATION: "New process group configuration",
    CONFIGURATION_NAME: "Configuration name",
    PROCESS_GROUP_ID: "Global name",
    EDIT_CONFIGURATION: "Edit process group configuration",
    DELETE_CONFIGURATION: "Delete process group configuration",
    PROCESSES: "View",
    EDIT_COUNTRY: "Edit country values",
    COUNTRY_NAME: "Country name",
    CURRENCY_CODE: "Currency code",
    CURRENCY_CODE_TOOLTIP: "ISO 4217 standard, e.g. USD, EUR.",
    PROJECTS_FLAG: "Projects flag",
    PROJECTS_SET_MANUALLY: "Projects set manually",
    PROJECTS_FROM_ERP_SYSTEM: "Projects from ERP systems",
    PROJECTS_NONE: "None",
    EDIT_FEATURE: "Edit feature flags",
    PARTTIMEVACATION: "Part-time vacation",
    CODE: "Code",
    CODE_TOOLTIP: "ISO 3166-1 Alpha-2 code standard, e.g. US, GB.",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder",
    EDIT_SENIORITY_LEVELS: "Edit levels",
    PROFIT_CENTER_ASSIGNED_ERROR: "You can't delete the profit center, because it is assigned to at least one team.",
    VALUES: {
      TITLE: "Values",
      COUNTRY_LABEL: "Name",
      COUNTRY_VALUE: "Value",
      EDIT: "Edit values"
    },
    HOLIDAYS: {
      TITLE: "Holidays calendar",
      ADD_NEW: "Add new day",
      DATE: "Day",
      SITE_NAME: "Site name",
      YEAR: "Year",
      ACTIONS: "Actions",
      DELETE: "Delete",
      NEW_HOLIDAY: "New holiday",
      DATE_PLACEHOLDER: "2012-12-25",
      DATE_TOOLTIP: "format: YYYY-MM-DD"
    },
    FEATUREFLAG: {
      TITLE: "Feature flags",
      EDIT: "Edit flags",
      FEATURE: "Feature",
      VISIBLE: "Visible"
    },
    INTERRUPTS: {
      TITLE: "Interrupt configurations",
      SEARCH: "Type name",
      NAME: "Name",
      DESCRIPTION: "Description",
      COUNTRY: "Country",
      HAS_SERVICE_LINE: "Has service line?",
      INCLUDE_IN_REPORTS: "Include in reports?",
      HAS_CLIENT: "Has client?",
      NEW: "Add new interrupt configuration",
      EDIT: "Edit",
      DELETE: "Delete",
      NEW_INTERRUPT: "New interrupt configuration",
      EDIT_INTERRUPT: "Edit interrupt configuration",
      DELETE_INTERRUPT: "Delete interrupt configuration",
      INTERRUPT_ID: "Interrupt name",
      ADD_CONFIRMATION: "Are you sure you want to add this interrupt configuration? You wouldn't be able to edit values 'Has service line?', 'Include in reports?' and 'Has client?'.",
      HAS_VALUE_ADDED: "Has VA option?"
    }
  },
  PROCESSES: {
    TITLE: "Processes",
    SEARCH: "Type name of a process",
    NEW: "Add new process",
    NAME: "Local translation",
    ID_NAME: "Global name",
    DESCRIPTION: "Local description",
    COMMENT_REQUIRED_BY_DEFAULT: "Comment by default",
    HAS_VOLUME_BY_DEFAULT: "Volume by default",
    VALUE_ADDED_BY_DEFAULT: "VA by default",
    INCLUDE_IN_REPORTS: "Include in reports",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_PROCESS: "New process",
    PROCESS_NAME: "Process name",
    PROCESS_DESCRIPTION: "Process description",
    PRODUCTIVITY_POINTS: "Productivity points",
    IS_HIDDEN: "Hidden",
    IS_OPPORTUNITY_TIME: "Opportunity time",
    IS_OPPORTUNITY_TIME_NO_ROEDL: "Invested time",
    IS_VACATION: "Is vacation",
    EDIT_PROCESS: "Edit process",
    DELETE_PROCESS: "Delete process",
    VOLUME_DEFINITION: "Volume definition",
    OUTPUT_TYPE_LIST: "Output list",
    OUTPUT_TYPE: "Output",
    OUTPUT_TYPE_DESCRIPTION: "Output type for a process",
    OUTPUTS: "Outputs",
    ALLOW_CHANGING_VALUE_ADDED: "Allow changing VA/NVA"
  },
  USERS: {
    TITLE: "Active users",
    SEARCH: "Type full name",
    FULL_NAME: "Full name",
    EMAIL_ADDRESS: "Email address",
    ROLE: "Role",
    IS_ADMIN: "Is master admin?",
    IS_LOCAL_ADMIN: "Is local admin?",
    IS_INTEGRATION_ADMIN: "Is integration admin?",
    CAN_EDIT_ACCEPTED: "Updates accepted",
    BLOCKED_AT_F: "Blocked at",
    EDIT: "Edit",
    RESTRICTED_CLIENT_ACCESS: "Restricted client access",
    USER_EDITION: "Edit user",
    CAN_EXPORT_WORKLOG: "Export",
    CAN_IMPORT_INCOME: "Import",
    CAN_IMPORT_INCOME_COUNTRYWIDE: "Import countrywide",
    CAN_UPDATE_RATES: "Edit Rates",
    CAN_VIEW_RATES: "View Rates",
    CAN_ACCESS360_VIEW: "360 view",
    CAN_ACCESS_FLEXITIME: "Flexitime view",
    MANAGEMENT_VIEW_HIDDEN: "Management view hidden",
    NEW: "Add new user",
    VIEW: "View",
    PASSWORD: "Password",
    SITE_ID: "Site name",
    SENIORITY_LEVEL: "Employee level",
    TYPE: "Work type",
    STANDARD_WORKING_HOURS: "Standard working hours",
    VALID_FROM: "Valid from",
    EDIT_USER: "Edit user",
    TEAM_ID: "Team",
    NEW_USER: "Add new user",
    BLOCK_CONFIRMATION: "Are you sure you want to block this user?",
    UNBLOCK_CONFIRMATION: "Are you sure you want to unblock this user?",
    UNBLOCK_WARNING: "Attention! If you unblock the user, all overtime will be recalculated for the period user was blocked.",
    BLOCK: "Block user",
    COUNTRY: "Country",
    CHANGETEAM :"Change team",
    MON: "Mon",
    TUE: "Tue",
    WED: "Wed",
    THU: "Thu",
    FRI: "Fri",
    SAT: "Sat",
    SUN: "Sun",
    MONDAY: "Monday",
    TUESDAY: "Tuesday",
    WEDNESDAY: "Wednesday",
    THURSDAY: "Thursday",
    FRIDAY: "Friday",
    SATURDAY: "Saturday",
    SUNDAY: "Sunday",
    PASSWORD_TOOLTIP: "Password must be at least 8 characters long, contain at least one symbol and uppercase character. eg. sDejQ9*3",
    OFFER_DATA_ENTRY: "Offer data entry",
    CALC_CLIENT_DATA_ACCESS: "Offer Calculator - Client data",
    CALC_TEMPLATES_ACCESS: "Offer Calculator - Templates (view only)",
    CALC_TEMPLATES_EDIT_ACCESS: "Offer Calculator - Templates (edit)",
    CALC_OFFER_BUILDER_ACCESS: "Offer Calculator - Offer builder",
    CALC_GLOBAL_BIDS_ACCESS: "Offer Calculator - Global tenders",
    CALC_PG_VIEW_ACCESS: "Offer Calculator - Process management (view only)",
    CALC_PG_EDIT_ACCESS: "Offer Calculator - Process management (edit)",
    CALC_DIRECT_LOG_IN: "Offer Calculator - Direct log in",
    DIRECT_O_CLOGIN: "Offer Calculator - Direct log in",
    CANIMPORTINCOMECOUNTRYWIDE_TOOLTIP: '"Can import income?" has to be chosen first',
    EXPORT: "Export",
    ACTIVE_FROM: "Active from",
    WILL_BE_BLOCKED_AT: "Will be blocked at",
    UNBLOCK: "Unblock",
    CALC_GLOBAL_TENDER_MANAGER: "Global Tender Manager",
    ACCEPT_PERSONAL_WORKLOGS: "Accept personal worklogs",
    INVOICED_TIME: "Invoicing time" ,
    PROJECT_VISIBILITY_FROM_D365: "D365 WBS visibility restriction",
    FORCE_POWER_USER: "Force Power User",
  },
  BLOCKED_USERS: {
    TITLE: "Blocked users",
    SEARCH: "Type full name",
    EDIT: "Edit",
    FULL_NAME: "Full name",
    EMAIL_ADDRESS: "Email address",
    ROLE: "Role",
    SENIORITY_LEVEL: "Employee level",
    TYPE: "Work type",
    STANDARD_WORKING_HOURS: "Standard working hours",
    IS_ADMIN: "Is master admin?",
    IS_LOCAL_ADMIN: "Is local admin?",
    IS_INTEGRATION_ADMIN: "Is integration admin?",
    CAN_EDIT_ACCEPTED: "Updates accepted",
    CAN_EXPORT_WORKLOG: "Export",
    CAN_IMPORT_INCOME: "Import",
    CAN_IMPORT_INCOME_COUNTRYWIDE: "Import countrywide",
    CAN_UPDATE_RATES: "Edit Rates",
    CAN_VIEW_RATES: "View Rates",
    MANAGEMENT_VIEW_HIDDEN: "Management view hidden",
    CAN_ACCESS360_VIEW: "360 view",
    CAN_ACCESS_FLEXITIME: "Flexitime view",
    COUNTRY: "Country",
    BLOCKED_AT_F: "Blocked at",
    VIEW: "View",
    UNBLOCK: "Unblock",
    EXPORT: "Export"
  },
  ADMIN_CLIENTS: {
    TITLE: "Clients",
    SEARCH: "Type client name",
    NEW: "Add new client",
    NAME: "Legal entity name",
    TAX_ID: "Tax id",
    COUNTRY: "Country",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_CLIENT: "New client",
    EDIT_CLIENT: "Edit client",
    DELETE_CLIENT: "Delete client",
    DELETE_CONFIRMATION: "Are you sure you want to remove relation to this client?",
    VIEW: "View",
    CLIENT_GROUP_NAME: "Client group name",
    CLIENT_GROUP_ID: "Client group name",
    HAS_PROJECTS: "Projects",
    VIEW_PROJECTS: "View projects",
    MDP_ID: "Master Data Portal ID",
    MDP_INFO: "Master Data Portal Name",
    MDP_NAME: "Master Data Portal Name",
    DOWNLOAD_CLIENT_NOTES: "Documentation",
    DEFAULT_BILLING_TYPE: "Default billing type",
    DEFAULT_BILLING_TYPE_NAME: "Default billing type",
    DEFAULT_BILLING_TYPE_ID: "Default billing type",
    MULTISELECT_KEYWORDS: "Multiselect",
    ADDITIONAL_INFO: "Additional informal prefix",
    ADDITIONALINFO_TOOLTIP: "This information does not affect the operation of the application, it is only for informational purposes. It will be displayed in parentheses wherever the client name appears."
  },
  ADMIN_WAITING_CLIENTS: {
    TITLE: "Potentially duplicated clients",
    NAME: "Name",
    TAX_ID: "Tax ID",
    ACCEPT: "Accept",
    DECLINE: "Decline",
    SEARCH: "Type client name, tax ID or status",
    CLIENT_STATUS: "Status",
    FROM_MDP: "From MDP",
    POTENTIAL_DUPLICATES: "Potential duplicates",
    SHOW_DECLINED_CLIENTS: "Show declined clients",
    HIDE_DECLINED_CLIENTS: "Hide declined clients",
    EDIT_ORIGIN: "Edit origin client",
    CLIENT: "Client",
    PICK_ORIGIN_CLIENT: "Pick origin client"
  },
  PROJECTS: {
    TITLE: "Projects",
    TEXT_ID: "Text identifier",
    NAME: "Name",
    FROM_DATE: "From",
    TO_DATE: "To",
    NO_EXPIRATION_DATE: "This project does not have expiration date",
    NO_EXPIRATION_DATE_SHORT: "No expiration date",
    ADD_NEW_PROJECT: "Add new project",
    EDIT: "Edit",
    ARCHIVE: "Archive",
    ARCHIVE_CONFIRMATION: "Are you sure you want to archive this project?",
    NEW_PROJECT: "New project",
    CLIENT: "Client",
    EDIT_PROJECT: "Edit project",
    ARCHIVE_PROJECT: "Archive project",
    TOOLTIP_ERP: "Projects are automatically taken from ERP system, to edit the project make necessary corrections directly it in the source ERP system"
  },
  ARCHIVED_PROJECTS: {
    TITLE: "Archived projects",
    TEXT_ID: "Text identifier",
    NAME: "Name",
    FROM_DATE: "From",
    TO_DATE: "To",
    RESTORE: "Restore",
    RESTORE_CONFIRMATION: "Are you sure you want to restore this project?"
  },
  TEAM_CLIENTS: {
    TITLE: "Clients",
    SEARCH: "Type client name",
    NEW: "Assign a client",
    NAME: "Name",
    TAX_ID: "Tax id",
    COUNTRY: "Country",
    EDIT: "Edit",
    REMOVE: "Remove",
    NEW_CLIENT: "New client",
    EDIT_CLIENT: "Edit client",
    DELETE_CLIENT: "Delete client",
    DELETE_CONFIRMATION: "Are you sure you want to delete this client?",
    VIEW: "View",
    CLIENT_GROUP_NAME: "Client group name",
    CLIENT_GROUP_ID: "Client group name",
    EXPORT: "Export",
    DOWNLOAD_CLIENT_NOTES: "Documentation",
    DEFAULT_BILLING_TYPE_NAME: "Default billing type",
    DISPLAY_NAME: "Name"
  },
  CLIENT_GROUPS: {
    TITLE: "Client groups",
    SEARCH: "Type client group name",
    NEW: "Add new client group",
    NAME: "Name",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_CLIENT_GROUP: "New client group",
    EDIT_CLIENT_GROUP: "Edit client group",
    DELETE_CLIENT_GROUP: "Delete client group"
  },
  SERVICE_LINES: {
    TITLE: "Service lines",
    SEARCH: "Type service line name",
    NEW: "Add new service line",
    NAME: "Name",
    NEW_SERVICE_LINE: "New service line"
  },
  SITES: {
    TITLE: "Sites",
    SEARCH: "Type site name",
    NEW: "Add new site",
    NAME: "Name",
    COUNTRY: "Country",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_SITE: "New site",
    EDIT_SITE: "Edit site",
    DELETE_SITE: "Delete site"
  },
  TEAMS: {
    TITLE: "Teams",
    SEARCH: "Type team name",
    NEW: "Add new team",
    NAME: "Name",
    SERVICE_LINE: "Service line",
    COUNTRY: "Country",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_TEAM: "New team",
    EDIT_TEAM: "Edit team",
    DELETE_TEAM: "Delete team",
    VIEW: "View",
    EXCLUDE_FROM_PROFITABILITY_REPORT: "Exclude from profitability view",
    TEAM_NAME: "Team name",
    WHEN: "Valid from",
    ARCHIVED: "Archived",
    EXPORT: "Export",
    PROFIT_CENTER: "Profit center",
    PROFIT_CENTER_ID: "Profit center"
  },
  PROBLEMS: {
    TITLE: "Problems",
    SEARCH: "Type problem name",
    NEW: "Add new problem",
    NAME: "Name",
    DESCRIPTION: "Description",
    EDIT: "Edit",
    DELETE: "Delete",
    NEW_PROBLEM: "New problem",
    EDIT_PROBLEM: "Edit problem",
    DELETE_PROBLEM: "Delete problem"
  },
  LICENSE_AGREEMENTS: {
    TITLE: "License agreements",
    SEARCH: "Type name",
    NEW: "New invitation",
    NEW_INVITATION: "New invitation",
    CANCEL_INVITATION: "Delete invitation",
    EMAIL: "E-mail address",
    NAME: "Name",
    LEGAL_ROLE: "Legal Role",
    LEGAL_ENTITY_ROLE: "Legal Entity Role",
    STATUS: "Status",
    RESEND: "Resend",
    CANCEL: "Cancel",
    DOWNLOAD: "Download",
    VIEW: "View",
    ACCEPTED: "Accepted",
    WAITING: "Waiting",
    SUCCESS: {
      RESEND: "Invitation has been resent successfully.",
      SEND: "Invitation has been sent successfully."
    },
    CONFIRMATION: {
      RESEND: "Do you really want to resend the invitation?",
      CANCEL: "Do you really want to cancel the invitation?"
    }
  },
  LICENSE_AGREEMENT: {
    TITLE: "License agreement",
    SUBHEADER: {
      DATA: "Invoicing data",
      CONTACT: "Contact person",
      UPLOAD: "Upload the document"
    },
    TAX_CERTIFICATE: "Tax certificate of residence required",
    COMPANY: "Company Name",
    COUNTRY: "Country",
    ADDRESS1: "Address ",
    ADDRESS1_INFO: "(Street name, Code, Town)",
    INTRA_COMMUNITY_VAT_NUMBER: "VAT number for intracommunity purposes",
    NO_INTRA_COMMUNITY_VAT: "I do not have",
    LOCAL_VAT_NUMBER: "VAT number for local purposes",
    NO_LOCAL_VAT: "I do not have",
    TAX_ID_NUMBER: "Tax ID number ",
    TAXIDNUMBER_INFO: "(other tax identification number)",
    PHONE_NUMBER: "Phone number",
    INVOICES_EMAIL_ADDRESS: "E-mail for receiving invoices",
    SEND: "Send",
    ADD_FILE: "Add your files or select a document",
    CHANGE_FILE: "Change files",
    ADD_MORE_FILES: "Add files",
    UPLOAD: "Upload",
    CONTACT_DATA: {
      MAIN_CONTACT_PERSON_NAME: "Name",
      MAIN_CONTACT_PERSON_EMAIL_ADDRESS: "E-mail",
      MAIN_CONTACT_PERSON_PHONE_NUMBER: "Phone"
    },
    TEXT: {
      UPLOAD: "stating you are empowered to represent given entity",
      TAX_CERTIFICATE: "Please consider consulting with your accountant to establish whether you need tax residency certificate."
    },
    LONG_TEXT: "Provision of data in the above form is voluntary but necessary to conclude and perform the contract.\n\n" +
      "Please be informed that the controller of your personal data is Roedl Outsourcing sp. z o.o. with its\n" +
      "registered office at ul. Sienna 73, 00-833 Warsaw. Your personal data will be processed to establish a\n" +
      "legal relationship and provide services thereunder. The basis for the processing of personal data for\n" +
      "that purpose is the agreement performance and our legitimate interest – establishment of a business\n" +
      "relationship.\n\n" +
      "Please be informed that the data controller has appointed a Data Protection Officer.\n\n" +
      "The disclosed personal data will be processed throughout the agreement lifetime. Furthermore, we will\n" +
      "process personal data for the time necessary to determine or defend potential claims.\n\n" +
      "You have a right to: (1) request that we inform you in detail about the way we use your personal data;\n" +
      "(2) request that we provide you with access to your personal data and with the backup copies of the\n" +
      "data disclosed to us; (3) receive the personal data you disclosed to us in a structured, commonly used\n" +
      "and machine-readable format and – as far as technically feasible – request that the data be transferred\n" +
      "to another controller without any difficulties, if the data are processed based on your consent and by\n" +
      "automated means; (4) request that we rectify any inaccuracies in the data that we hold; (5) request that\n" +
      "we delete all data for the processing of which we no longer have legal grounds; (6) request that we\n" +
      "restrict the processing of your personal data e.g. for the period of handling a complaint, (7) complain\n" +
      "to the supervisory body – the President of the Personal Data Protection Office.\n\n" +
      "If the basis for the processing of your data is our legitimate interest, you can object to the processing\n" +
      "of your personal data. Your objection will be acknowledged, unless the grounds on which we\n" +
      "processes your data override your interests, rights and freedoms.\n\n" +
      "To exercise your rights, please send your statements/requests to the following e-mail address:\n" +
      "gdpr.biznes@roedl.com or the registered address of the data controller as provided above. The\n" +
      "personal data processed by the controller may be transmitted only to entities which provide and\n" +
      "support the controller’s ICT systems and host the controller's website.\n\n" +
      "Your personal data is processed in the European Union.",
    CONSENTS: {
      YES: "Yes",
      NO: "No",
      LICENSE_AGREEMENT_ACCEPTED: "Accept licensing agreement",
      DATA_PROCESSING_AGREEMENT_ACCEPTED: " Accept data processing agreement",
      ACCEPT: "Accept",
      LICENSING: "licensing",
      AGREEMENT: "agreement"
    },
    THANK_YOU: {
      TEXT: "Thank you! Copy of your agreement has been sent to your email.",
      CLOSE: "Close"
    }
  },
  USER: {
    TITLE: "User",
    EDIT: "Edit user",
    EDIT_USER: "Edit user",
    USER_LABEL: "Name",
    USER_VALUE: "Value",
    FULL_NAME: "Full name",
    EMAIL_ADDRESS: "Email address",
    ROLE: "Role",
    SITE_ID: "Site name",
    SENIORITY_LEVEL: "Employee level",
    STANDARD_WORKING_HOURS: "Standard working hours",
    VALID_FROM: "Valid from",
    CAN_EDIT_ACCEPTED: "Updates accepted",
    CAN_EXPORT_WORKLOG: "Can export worklog?",
    CAN_IMPORT_INCOME: "Can import income?",
    CAN_IMPORT_INCOME_COUNTRYWIDE: "Can import income countrywide?",
    CAN_UPDATE_RATES: "Edit cost rates",
    CAN_VIEW_RATES: "View cost rates",
    CAN_ACCESS360_VIEW: "360 view",
    CAN_ACCESS_FLEXITIME: "Flexitime view",
    MANAGEMENT_VIEW_HIDDEN: "Management view hidden",
    IS_ADMIN: "Is master admin?",
    IS_LOCAL_ADMIN: "Is local admin?",
    IS_INTEGRATION_ADMIN: "Is integration admin?",
    BLOCKED_AT: "Blocked at",
    OFFER_DATA_ENTRY: "Offer data entry",
    CANIMPORTINCOMECOUNTRYWIDE_TOOLTIP: '"Can import income?" has to be chosen first',
    RESEND_PASSWORD_LINK_1: "Resend password change email",
    RESEND_PASSWORD_LINK_2: "or copy password change link",
    RESTRICTED_CLIENT_ACCESS: "Restricted client access",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder",
    ACCEPT_PERSONAL_WORKLOGS: "Accept personal worklogs",
    PROJECT_VISIBILITY_FROM_D365: "D365 WBS visibility restriction",
    INVOICED_TIME: "Invoicing time",
    FORCE_POWER_USER: "Force Power User"
  },
  USERS_DIALOG: {
    TITLE: "User",
    EDIT: "Edit user",
    EDIT_USER: "Edit user",
    COUNTRY: "Country",
    TEAM_ID: "Team name",
    USER_LABEL: "Name",
    USER_VALUE: "Value",
    FULL_NAME: "Full name",
    EMAIL_ADDRESS: "Email address",
    ROLE: "Role",
    SITE_ID: "Site name",
    SENIORITY_LEVEL: "Employee level",
    STANDARD_WORKING_HOURS: "Standard working hours",
    VALID_FROM: "Valid from",
    CAN_EDIT_ACCEPTED: "Updates accepted",
    CAN_EXPORT_WORKLOG: "Can export worklog?",
    CAN_IMPORT_INCOME: "Can import income?",
    CAN_IMPORT_INCOME_COUNTRYWIDE: "Can import income countrywide?",
    CAN_UPDATE_RATES: "Edit cost rates",
    CAN_VIEW_RATES: "View cost rates",
    CAN_ACCESS360_VIEW: "360 view",
    CAN_ACCESS_FLEXITIME: "Flexitime view",
    MANAGEMENT_VIEW_HIDDEN: "Management view hidden",
    IS_ADMIN: "Is master admin?",
    IS_LOCAL_ADMIN: "Is local admin?",
    IS_INTEGRATION_ADMIN: "Is integration admin?",
    BLOCK_USER: "Block user",
    EDIT_BLOCKED_USER: "Edit blocked user",
    EDIT_TEAM: "Edit team",
    CURRENT_TEAM: "Current team",
    NEW_TEAM_1: "New team - first",
    NEW_TEAM_2: "New team - second",
    CURRENT_DATE: "Current date",
    DATE: "Date",
    TEAM_ID_STATIC: "Team name",
    CANIMPORTINCOMECOUNTRYWIDE_TOOLTIP: '"Can import income?" has to be chosen first',
    ACTIVE_FROM: "Active from",
    INVOICED_TIME: "Invoicing time",
    PROJECT_VISIBILITY_FROM_D365: "D365 WBS visibility restriction",
    FORCE_POWER_USER: "Force Power User",
  },
  USER_OFFER_CALC: {
    FULL_NAME: "Full name",
    CALC_CLIENT_DATA_ACCESS: "Client data",
    CALC_TEMPLATES_ACCESS: "Templates (view only)",
    CALC_TEMPLATES_EDIT_ACCESS: "Templates (edit)",
    CALC_OFFER_BUILDER_ACCESS: "Offer builder",
    CALC_GLOBAL_BIDS_ACCESS: "Global tenders",
    CALC_PG_VIEW_ACCESS: "Process management (view only)",
    CALC_PG_EDIT_ACCESS: "Process management (edit)",
    CALC_DIRECT_LOG_IN: "Direct log in",
    DIRECT_O_CLOGIN: "Direct log in",
    USER_LABEL: "Name",
    USER_VALUE: "Value",
    EDIT_OC_ACCESS: "Edit access",
    EDIT_USER_OC_ACCESS: "Edit offer calculator access",
    TITLE: "Offer calculator access",
    CALC_GLOBAL_TENDER_MANAGER: "Global tender manager",
  },
  RATES: {
    TITLE: "Rates",
    SEARCH: "Search by rate, employee level etc.",
    RATE: "Rate",
    SENIORITY_LEVEL: "Employee level",
    SITE_NAME: "Site name",
    VALID_FROM: "Valid from",
    PROFIT_CENTER_NAME: "Profit center name",
  },
  API: {
    TITLE: "API keys",
    SEARCH: "Search by name",
    NAME: "Name",
    ADD: "Add new API key",
    REGENERATE: "Regenerate",
    EDIT: "Edit",
    DELETE: "Delete",
    EDIT_VENDOR: "Edit API key",
    DELETE_VENDOR: "Delete API key",
    NEW_VENDOR: "New API key",
    EMAIL_ADDRESS: "Email",
    IP_ADDRESSES: "IP adresses",
    ENDPOINTS: "Endpoints",
    SITES: "Sites",
    USERS: "Users",
    TEAMS: "Teams",
    EMPLOYEES: "Employees",
    PROCESS_GROUPS: "Process groups",
    PROCESSES: "Processes",
    INTERRUPTS: "Interrupters",
    CLIENT_GROUPS: "Client groups",
    CLIENTS: "Clients",
    PROCESS_CLIENT_CONFIGURATIONS: "Process client configurations",
    INCOME: "Income",
    WORKLOGS: "Worklogs",
    PROJECTS: "Projects",
    SUCCESS: {
      REGENERATE: "API key regenerated successfully."
    },
    CONFIRMATION: "Do you really want to regenerate API key?",
    IPADDRESSES_TOOLTIP: "Proper IP format e.g. 198.51.100.1",
    IP_ADDRESSES_RANGES : "IP adresses ranges",
    IPADDRESSESRANGES_TOOLTIP: "Proper IP format e.g. 198.51.100.1/24",
  },
  CLIENT_CONFIGUARTIONS: {
    DELETE_CONFIRMATION: "Are you sure you want to delete this process group with configurations?",
    SEARCH: "Search by name",
    COMMENT_REQUIRED: "Comment required?",
    HAS_VOLUME: "Has volume?",
    VALUE_ADDED: "Value added?",
    EDIT: "Edit",
    NAME: "Local translation",
    ID_NAME: "Global name"
  },
  POSITIONS: {
    TITLE: "Positions",
    NEW: "Add new position",
    SEARCH: "Search position by site name, employee level etc.",
    SITE_NAME:"Site name",
    SENIORITY_LEVEL_NAME: "Employee level",
    TYPE: "Work type",
    VALID_FROM: "Valid from",
    VALID_FOR: "Valid for",
    EDIT: "Edit",
    MON: "Standard working hours",
    MOND: "Mon",
    TUE: "Tue",
    WED: "Wed",
    THU: "Thu",
    FRI: "Fri",
    SAT: "Sat",
    SUN: "Sun"
  },
  POSITION: {
    ADD_POSITION: "Add new position",
    EDIT_POSITION: "Edit position",
    SITE_ID: "Site name",
    WORKNORM: "Worknorm",
    LONGTERMLEAVE: "Long Term Leave",
    HOURLYNORM: "Hourly",
    SENIORITY_LEVEL: "Employee level",
    STANDARD_WORKING_HOURS: "Standard working hours.",
    HOURLY_WORKING_HOURS:"Hourly working norm.",
    HOURLYWORKINGHOURS_TOOLTIP: "Hourly working norm. Work based on factual time reported approach with no overtimes or undertimes and no standard worknorm.",
    STANDARDWORKINGHOURS_TOOLTIP: "Work based on traditional worknorm approach with undertimes and overtimes calculated based on reported data.",
    TYPE: "Work type",
    VALID_FROM: "Valid from",
    MON: "Mon",
    TUE: "Tue",
    WED: "Wed",
    THU: "Thu",
    FRI: "Fri",
    SAT: "Sat",
    SUN: "Sun"
  },
  RESTRICTED: {
    IS_ALLOWED: "is allowed?",
    CLIENT_NAME: "client",
    TITLE: "Clients access",
    SEARCH: "Search clients by restricted access",
    EDIT_ACCESS: "Change access",
  },
  TEAM_CLIENT: {
    VALUES: {
      TITLE: "Values",
      ADD_PROCESSES: "Add new process group configurations",
      CLIENT_LABEL: "Value name",
      CLIENT_VALUE: "Value"
    }
  },
  CLIENT_PROCESS: {
    EDIT_PROCESS: "Edit process",
    COMMENT_REQUIRED: "Comment required?",
    HAS_VOLUME: "Has volume?",
    VALUE_ADDED: "Value added?",
    DELETE_PROCESS: "Delete process group",
    NEW_PROCESS_GROUP: "Adding new process group configurations",
    OTHER_PROCESS_GROUPS: "Other process group configurations:",
    NAME: "Local translation",
    ID_NAME: "Global name",
    DESCRIPTION: "Description",
    ADD: "Add",
    REMOVE: "Remove",
    NOTHING_MORE: "Nothing more to add",
    MAIN_TITLE_TOOLTIP: "Configure process structure with Volume and VA/NVA markings according with Service Level Agreement"
  },
  ADD_SOMETHING: "Add some data",
  TEAM: {
    NEW_CLIENT: "New client configuration",
    CLIENT: "Client",
    SUGGESTED_PGC: "Suggested process group configurations:",
    NAME: "Name",
    DESCRIPTION: "Description",
    ADD_REMOVE: "Add/Remove",
    ADD: "Add",
    REMOVE: "Remove",
    UNUSED_PGC: "Unused process group configurations:",
    PROCESS_GROUP_CONFIGURATIONS: "Process group configurations:",
    INTERNAL_CONFIGURATIONS: "Internal configurations",
    ASSIGN: "Assign",
    MARK_CLIENT: "Mark clients to assign or select all",
    CLIENTS_SELECTED: "Selected",
    SELECT_ALL: "Select all",
    NO_CLIENTS: "No client with such a name",
    SEARCH: "Type client name"
  },
  OVERTIME_MANAGEMENT: {
    TITLE: "Overtime Management",
    SEARCH: "Search by date or mode",
    NEW: "New overtime mode",
    EDIT: "Edit",
    EDIT_OVERTIME: "Edit overtime",
    VALID_FROM: "Valid from",
    MODE: "Mode",
    MANAGEMENT_MODE: "Mode",
    NEW_OVERTIME: "Add new overtime mode"
  },
  ADMIN_CLIENT: {
    NAME: "Name",
    TAX_ID: "Tax id",
    COUNTRY: "Country",
    GROUP_NAME: "Group name",
    DEFAULT_BILLING_TYPE: "Default billing type",
    MULTISELECT_KEYWORDS: "Multiselect",
    ADDITIONAL_INFO: "Additional informal prefix"
  },
  PROFIT_CENTER_RATES: {
    RATES: "Rates",
    SELECT_PROFIT_CENTER: "Select profit center to manage its rates:",
    PROFIT_CENTERS: "Profit Centers",
    ADD_RATE: "Add new rate",
    ADD_NEW_LEVEL: "Add new employee level rate",
    VALID_FROM: "Valid from",
    SENIORITY_LEVEL: "Employee level",
    CURRENT_RATES: "Current rates",
    ERROR: "Error saving! Check if 'Valid from' is not in the past, and rate is not negative!",
    ARCHIVAL_RATES: "Archival rates",
    UPDATED_ARCHIVED_RATE: "Update archived rate",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder",
    NULL_ERROR: "At least one field is blank. Fill in the missing fields."
  },
  CONTROLLING: {
    INCOME_IMPORT: "Income import",
    SELECT_PROFIT_CENTERS: "Select profit centers",
    SELECT_TEAMS_FOR_IMPORT: "Select teams to import income spreadsheet to:",
    SELECT_TEAMS_FOR_EXPORT: "Select teams to export data from:",
    SELECT_YEAR: "Select year:",
    SELECT_MONTH: "Select month:",
    SELECT_TEAM_AND_PERIOD: "Select teams and month",
    SELECT_PERIOD: "Select period",
    SELECT_SITES: "Select sites",
    SELECT_SERVICE_LINES: "Select service lines",
    DOWNLOAD_TEMPLATE: "Download interface file",
    DOWNLOAD: "Download data",
    UPLOAD_INCOME_EXCEL: "Upload income Excel file",
    FETCH_INCOME_CASEMAN: "Download income from CASEman",
    FETCH_INCOME_REPORT: "Download synchronization report",
    TEAM_INCOME: "Team Income",
    TAX_ID: "Tax Id",
    INCOME: "Income",
    INCOME_EXCLUDE_NO_TIME: "(only clients with time reported)",
    INCOME_NO_TIME: "(clients with income but no time reported)",
    ERROR_UPLOADING: "Error uploading Excel file",
    EXPORT: "Data export",
    DATE_START: "Start date",
    DATE_END: "End date",
    SELECT_FIELDS: "Select data fields you want to export:",
    NO_SUBTEAMS_WARNING: "You have no subordinate teams",
    NO_SUBTEAMS: "You have no subordinate teams for such criteria",
    INCLUDE_ALL: "Include all clients assigned to teams",
    EXCLUDE_NO_TIME: "Exclude clients with no time reported",
    NO_TIME_REPORTED: "No time reported",
    TEAM_S: "Team(s)",
    ERROR_NOTES: {
      WRONG_NUMBER_COLUMNS: "Wrong number of columns",
      NO_CLIENT_OR_TEAM: "Couldn't find client or team defined in income xlsx",
      NO_VALID_NUMBER: "The amount cell is not a valid number. Either change the cell column type to a number or make the amount look like this: 134444.56",
      CANT_CONVERT: "An error occurred while converting",
      UPLOAD_FAILED: "Upload xlsx income failed",
      WRONG_NAME_FORMAT: "File name has wrong format",
      INVALID_FORMAT: "Invalid file format"
    }
  },
  ADMIN_RATES: {
    TITLE: "Profit Centers",
    SEARCH: "Search by country, site name, etc.",
    COUNTRY: "Country",
    SITE_NAME: "Site name",
    SENIORITY_LEVEL: "Employee level",
    RATE: "Rate",
    VALID_FROM: "Valid from",
    PROFIT_CENTER_NAME: "Profit Center name",
    SENIORITY_LEVEL_NAME: "Employee level"
  },
  MANAGEMENT: {
    VIEW_HEADER: "Management view",
    COUNTRIES: "Select countries",
    PROFIT_CENTERS: "Select profit centers",
    SITES: "Select sites",
    SERVICE_LINES: "Select service lines",
    TEAMS: "Select teams",
    START_DATE: "Start date",
    END_DATE: "End date",
    DOWNLOAD: "Download",
    ERROR: "Error downloading! Check if 'End date is not in the past.'",
    SELECT_ALL: "Select all"
  },
  DIALOG_CARD: {
    COMMENT_REQUIRED: "Requiring comments",
    COMMENT_NOT_REQUIRED: "Not requiring",
    ALL_COMMENTS_REQUIRED: "Force requiring comments",
    ALL_COMMENTS_NOT_REQUIRED: "Force not requiring comments",
    CONFIRMATION_TEXT: "The change only applies to instances already created. Remember that new instances will be created with the current settings. Check that you do not need to update your settings.",
    HAVE_VOLUME: "With volume info",
    HAVE_NOT_VOLUME: "Without volume",
    ALL_HAVE_VOLUME: "Force volume info",
    ALL_HAVE_NOT_VOLUME: "Force volume info off",
    HAVE_VALUE_ADDED: "Value added",
    HAVE_NOT_VALUE_ADDED: "Not value added",
    ALL_HAVE_VALUE_ADDED: "Force value added",
    ALL_HAVE_NOT_VALUE_ADDED: "Force no value added",
    WARNING_LABEL: "WARNING",
    CONFIRM: "Confirm",
    BLOCKED: "Please change the data!",
    SAME_TAX_ID: "This TAX ID already exist in client: ",
    CHANGE_IT: "Please change it!",
    SAME_CLIENT_NAME: "This NAME already exist.",
    SIMILAR_NAMES: "Client(s) with similar name already exist(s).",
    CHANGE_AND_CONFIRM: "Please change it or confirm duplicates by clicking 'Submit'!",
    SIMILAR_CLIENTS: "Similars:",
  },
  CASEMAN: {
    ACTIVE_TOOLTIP: "Inactive clients are clients that have no time reported for the last 6 months, counted from the present month",
    ADD_EXCEPTION: "Add Exception",
    ALL: "All",
    ALL_TO_SETTLE: 'All "to settle"',
    ALL_NOT_TO_SETTLE: 'All "not to settle"',
    VA_TO_SETTLE_NVA_NOT: 'VA to "to settle", NVA to "not to settle"',
    CASEMAN: "Caseman",
    CLIENT_CASEMAN: "Client (CASEMAN)",
    CLIENT_CONFIG_ERP: "Clients",
    CLIENT_CONFIG: "Clients Config",
    CLIENT_KLIX: "Client (KliX)",
    CLIENT: "Client",
    CLIENTS_KLIX: "Clients in KliX",
    CONFIG: "Config",
    CONFIGURE_TEAM: "No team config. You need to create team config first.",
    COUNTRY: "Country",
    CURRENT_STRATEGY: "Your current strategy is:",
    CURRENT_TEAM: "Team: ",
    DELETE: "Delete",
    EDIT: "Edit",
    EXCEPTIONS: "Exceptions",
    EXPORT_SYNC_PROBLEMS: "Export sync problems",
    FROM: "from",
    HIDDEN: "[hidden]",
    INCOME_OVERWRITE: "There are incomes defined for the given date. Fetching incomes may overwrite existing data. Continue?",
    INTEGRATION_SETTINGS: "Integration Settings",
    INTERRUPT_KLIX: "Interrupt (KliX)",
    INTERRUPT: "Interrupt",
    INTERRUPTS: "Interrupts",
    JOBCODE_CASEMAN: "Jobcode (CASEMAN)",
    JOBCODE: "Jobcode",
    MATCH: "Match",
    MATCHING_CLIENT: "Clients (KliX)",
    MATCHING_ERP: "Customization",
    MATCHING_INTERRUPTS: "Matching Interrupts KliX and Project CASEMAN",
    MATCHING_PROJECTS: "Matching Process KliX and Project CASEMAN",
    MATCHING: "Matching",
    NO_CLIENTS: "There are no clients in this country",
    NO_PROJECTS_AVAILABLE: "No projects available",
    NO_PROJECTS: "No projects",
    NO_TEAM_INFO: "No team has been matched. Please contact Integration admin.",
    ONLY_ACTIVE: "Show only active clients",
    PG_CONFIG_ERP: "Process Groups and Processes",
    PG_CONFIG: "Process Groups Config",
    PROCESS_FOR_PG: "Process for Process Group",
    PROCESS_GROUP_KLIX: "Process Group (KliX)",
    PROCESS_GROUP: "Process group",
    PROCESS_GROUPS: "Process Groups in KliX",
    PROCESS_KLIX: "Process (KliX)",
    PROCESS: "Process",
    PROJECT_CASEMAN: "Project (CASEMAN)",
    PROJECT_CONFIG: "Projects Config",
    PROJECT: "Project",
    PROJECTS: "Projects",
    ROOT_CONFIG: "CASEMAN root config",
    SELECT_DATE_PLACEHOLDER: "Pick a date",
    SELECT_PROCESS_GROUPS: "Select Process Group",
    SELECT_PROCESS: "Select Process",
    SELECT_PROJECT: "Select project",
    SELECTED_DATES: "Pick date",
    SHOW_HIDDEN: "Show hidden processes",
    SITE_CASEMAN: "Site (CASEMAN)",
    SITE_KLIX: "Site (KliX)",
    SITE: "Site",
    SITES_KLIX: "Sites (KliX)",
    SITES: "Sites",
    SUBCODE_CASEMAN: "Subcode (CASEMAN)",
    SUBCODE: "Subcode",
    SYNC: "Sync",
    TEAM_CASEMAN: "Team CASEMAN",
    TEAM_CONFIG_ERP: "Teams",
    TEAM_CONFIG: "Teams Config",
    TEAM_KLIX: "Team KliX",
    TEAM: "Team",
    TEAMS_CASEMAN: "Teams CASEMAN",
    TEAMS_KLIX: "Teams KliX",
    TO: "to",
    USER_CASEMAN: "User (CASEMAN)",
    USER_CONFIG_ERP: "Users",
    USER_CONFIG: "Users Config",
    USER_KLIX: "User (KliX)",
    USER: "User",
    USERS_KLIX: "Users in KliX",
  },
  CASEMAN_SYNC: {
    AGGREGATE_JOBCODE: "client-jobcode",
    AGGREGATE_PROCESS: "klix process",
    AGGREGATE_PROJECT_JOBCODE: "caseman project-jobcode",
    AGGREGATE_TYPE: "Aggregation type: ",
    AUTO_SYNC_FOR_ALL: "Auto sync for all users",
    AUTOSYNC_TOOLTIP: "AUTO mode will automatically send data to CASEman at 23:30 every day for the given day. Please note that other dates are not synchronized automatically and manual synchronization must apply here",
    AUTOSYNC: "Auto",
    CHECK_ALL: "Check all",
    CHECK: "Check",
    CLIENT: "Client",
    COMMENT: "Comment",
    COUNTRY: "Country",
    CUSTOMIZATION: "Customization",
    DATE: "Date",
    DEAD: "Caseman is dead.",
    DONE: "Done",
    DURATION: "Rounded duration",
    FAIL: "Fail",
    FAILED: "failed",
    FROM: "from",
    INVOICE_DETAILS: "Invoice details",
    JOBCODE: "Jobcode",
    MINUTES: "min",
    NO_PACKAGES: "There are no packages in the chosen period of time.",
    NOT_SENT: "not sent",
    OFF: "Off",
    ON: "On",
    PAID: "Paid/Not",
    PICK_DATES: "Pick date",
    PROBLEM: "Problem",
    PROJECT: "Project",
    REPORT_LANGUAGE: "Report language",
    SEND_REPORTS_TOOLTIP: "SEND REPORTS functionality will send a report about data that was not synchronized with CASEman while automatically synchronizing",
    SEND_REPORTS: "Send reports",
    SHOW_PROCESS_GROUPS_MAPPINGS: "Show JobCode mappings in tooltips for Process groups",
    SHOW_PROCESSES_MAPPINGS: "Show JobCode mappings in tooltips for Processes",
    STATS: "Stats",
    STATUS: "Status",
    SUBCODE: "Subcode",
    SUCCESS: "success",
    SYNC: "Sync",
    TO: "to",
    WORKLOGS_INFO: "KliX worklogs included in this package",
  },
  SEARCH_AND_SELECT: {
    NO_DATA: "no data"
  },
  TOOLTIP: {
    COUNTRY_FEATURE_FLAG_TOOLTIP: "Please contact Master admin in order to make these changes",
    COUNTRY_CLIENT_GROUP_NAME_TOOLTIP: "Please contact Master administrator to assign new client groups that are not on your country list",
    COUNTRY_CLIENT_ACTION_TOOLTIP: "Please contact Master administrator to delete the client",
    LOCAL_NAME_TOOLTIP: "Local translation must be strictly aligned with Global name",
    MAIN_TITLE_TOOLTIP: "Configure process structure with Volume and VA/NVA markings according with Service Level Agreement",
    LOCAL_DESCRIPTION_TOOLTIP: "Local translation are shown on process tooltip",
    OPPORTUNITY_TIME_TOOLTIP: "Contact master admin to change opportunity time configuration",
    NO_INCOMES_UPLOADED: "No incomes uploaded"
  },
  SUBMENU: {
    WORK_DATA: "Work data",
    WORKLOGS: "Worklogs",
    POWER_USER: "Power user",
    DAILY_REPORT: "Daily report",
    PROFITABILITY: "Profitability",
    OVERTIME: "Overtime",
    EXPORT: "Export",
    FLEXITIME: "Flexitime",
    VIEW_360: '360 view',
    OVERIME_APPLICATION: "Overtime request"
  },
  VIEW360: {
    AVERAGE_TIME_PER_UNIT: "Average time per unit",
    BY: "By",
    DOWNLOAD_TO_EXCEL: "Export all",
    MANAGE_SHARES: "Manage shares",
    EMPLOYEE_ROLE: "Employee Role",
    ENABLED: "Enabled",
    ENABLE_WORKLOG_EXPORT: "Enable worklog export",
    EXPORT: "Export",
    HIDDEN: "Hidden",
    MORE: "MORE",
    OTHERS: "No client group",
    PROCESS_GROUPS: "Process Groups",
    PROCESS_PROBLEMS: "Process Problems",
    RANGE_TOO_SMALL: "Selected date range is too small. Choose at least two months.",
    SELECT_PROCESS: "Select a process in the VOLUME SLICER TABLE",
    SHARE: "Share",
    SHARE_VIEW_AS_LINK: "Share all",
    SHARE_EXPIRE: "This link is active only for 7 days.",
    SHOW: "SHOW",
    SHOW_LESS: "SHOW LESS",
    TOGGLE_ALL: "Select All",
    VOLUME_SLICER_TABLE: "Volume Slicer Table",
    EXPIRED_MESSAGE: "The provided link has expired. Please contact the person who provided the link for more information.",
    SHOW_WORKLOG: "Share worklogs",
    SHOW_CHART: "Share charts",
    SET_NAME: "Set share name",
    SHOW_ZERO_VOL: "Show processes with 0 vol.",
    EMPLOYEES: "Employees",
    CLIENT_GROUPS: "Client groups",
    COPY: "Copy to clipboard",
    COPIED: "Copied to clipboard",
    CURRENCY: {
      APPLIED: "New currency applied",
      NEGATIVE_NUMBER: "Currency ratio can't be negative",
      QUESTION_PART1: "The closest available exchange rate is from ",
      QUESTION_PART2: ". Do you accept?",
      QUESTION_TWO_DATES_1: "The closest available exchange rates are from ",
      QUESTION_TWO_DATES_2: ". Choose one of the dates",
      LIVE: "Live",
      FIXED_DATE: "Fixed date",
      FIXED_RATE: "Fixed rate",
      EXCHANGE_RATE: "Exchange rate:",
      SOURCE: "Source:"
    },
    MODAL: {
      EDIT: "Edit",
      SHARES: "SHARES",
      CREATED: "CREATED",
      EXPIRES: "EXPIRES",
      VIEWS: "VIEWS",
      STATUS: "STATUS",
      ACTIONS: "ACTIONS",
      ACTIVATE: "Activate",
      DEACTIVATE: "Deactivate",
      DELETE: "Delete",
      ACTIVE: "Active",
      INACTIVE: "Inactive",
      ERROR_DATE: "Expired date is set up before creation date, change not applied",
      SUCCESS_DATE: "Time successfully changed to ",
      SUCCESS_DATE_END: "",
      SUCCESS_SAVED: "Saved",
      SUCCESS_RESTORED: "Successfully restored and extended for 7 days",
      QUESTION: "Are you sure you want link to expire?",
      QUESTION_DELETE: "Are you sure you want to delete?",
      SUCCESS_DELETED: "Successfully deleted",
      YES: "YES",
      NO: "NO",
      SUCCESS_EXPIRED: "Successfully set to expired",
      SUCCESS_ALLOCATION: "Allocated successfully"
    },
    WIDGETS: {
      TOTAL_TIME: "Total time",
      TOTAL_TIME_DESC: "Sum of employees time spent working for given client(s) for selected teams(s) in the selected time range",
      PROFITABILITY_DESC: "Effective profitability rate for given client(s) for selected teams(s) in the selected time range",
      HOURLY_RATE: "Hourly rate",
      HOURLY_RATE_DESC: "Effective hourly rate for given client(s) for selected teams(s) in the selected time range",
      TOTAL_TURNOVER: "Total turnover",
      TOTAL_TURNOVER_DESC: "Sum of incomes for given client(s) for selected teams(s) in the selected time range",
      VA_DESC: "% of time spent on processes in scope of the regular contract (Value added) for given client(s) for selected teams(s) in the selected time range",
      NVA_DESC: "% of time spent on processes outside the regular contract (Non value added) for given client(s) for selected teams(s) in the selected time range",
      TOTAL_COST: "Team(s) total cost",
      TOTAL_COST_DESC: "Sum of multiplied times and rates at employee levels",
      TOTAL_MARGIN: "Profit",
      TOTAL_MARGIN_DESC: "Total turnover reduced by total cost",
    }
  },
  FLEXITIME: {
    ACCEPTANCE_FILTER: "Acceptance filter",
    TYPE_FILTER: "Type filter",
    CLIENT_FILTER: "Client filter",
    CLIENT_GROUP_FILTER: "Client group filter",
    NEW_WORKLOG: "Add new worklog",
    EDIT_WORKLOG: "Edit worklog",
    DELETE_WORKLOG: "Delete worklog",
    DATE: "Date",
    START_AT: "Start at",
    DURATION: "Duration",
    HH_MM: "[hh:mm]",
    CLIENT_NAME: "Client name",
    SERVICE_LINE: "Service line",
    PROCESS_GROUP: "Process group",
    PROCESS: "Process",
    STATUS: "Status",
    ADD_NEW: "Add new",
    INTERRUPT: "Interruption",
    STATUSES: {
      STARTED: "Started",
      FINISHED: "Finished",
      ERROR: "Error",
    },
    WORKLOG_COPIED: "Worklog copied to clipboard.",
    PASTE_OR: "Choose the place to paste it or click ",
    ESC: "ESC",
    TO_ABORT: " to abort",
    PASTE: "Paste here",
    ADD_NEW_PROCESS: "Add new process",
    ADD_NEW_INTERRUPT: "Add new interrupt",
    REALLY: "Do you really want to abort?",
    CHANGES_WILL_LOST: "All unsaved changes will be lost.",
    UNSAVED_WARNING: "You have unsaved changes. Do you want to change location anyway? (Clicking OK will abort any unsaved worklogs)",
    SPLIT_MODAL: {
      DESCRIPTION: "Reported time exceeds the overall time for the request. Do you want to split the reported time into a request and a normal worklog?",
      NO_DESCRIPTION: 'If you choose "No", you have to edit this worklog before save.',
      YES: "Yes",
      NO: "No"
    }
  },
  SUBSCRIPTIONS: {
    TITLE: "Subscriptions and alerts",
    NEW: "Add",
    ADD_SUBSCRIPTION: "Add Subscription",
    EDIT_SUBSCRIPTION: "Edit Subscription",
    DELETE_SUBSCRIPTION: "Delete Subscription",
    TABLES: "Tables",
    SEND_AT_MONTH_DAY: "Send a report on every",
    SEND_AT: "Send at",
    EVERY_DAY: "day of the month",
    PROFITABILITY: "Profitability",
    HOURLY_RATE: "Hourly rate",
    DURATION: "Duration",
    EDIT: "Edit",
    DELETE: "Delete",
    SEND_SUBSCRIPTION: "Send subscription",
    DAY: "day",
    ADD_BUTTON_TOOLTIP: "For now it is possible to add only one subscription",
    LANGUAGE: "Language",
    CURRENCY: "Currency",
    CURRENCY_NAME: "Currency",
    LOCAL: "Local",
    LONG_TERM_REPORT_TWELVE_MONTHS: "Average",
    LONG_TERM_REPORT_TWELVE_MONTHS_INFO: "Average",
    SIX_MONTHS: "6 months",
    TWELVE_MONTHS: "12 months",
    TEAM: "Overtime",
    OVERTIME_SUBSCRIPTION: "Overtime",
    PROFITABILITY_SUBSCRIPTION: "Profitability",
    PROFITABILITY_SUBSCRIPTION_BUTTON: "Profitability subscription",
    OVERTIME_SUBSCRIPTION_BUTTON: "Overtime subscription",
    LEGAL_ALERT: "Legal",
    TEAM_NAME: "Overtime Request Team",
    TEAM_ID: "Team",
    ALL_TEAMS: "All teams",
  },
  OVERTIME_SUBSCRIPTIONS: {
    TITLE: "Overtime subscriptions",
    NEW: "Add new subscription",
    ADD_SUBSCRIPTION: "Add Subscription",
    EDIT_SUBSCRIPTION: "Edit Subscription",
    DELETE_SUBSCRIPTION: "Delete Subscription",
    EMPLOYEE: "Employee table",
    TEAM_TABLE: "Team table",
    ORDER_BY: "Main measure",
    ROWS: "Rows",
    TEAM_ACCEPTED_OVERTIME_THRESHOLD: "Accepted overtime threshold",
    TEAM_REPORTED_OVERTIME_THRESHOLD: "Reported overtime threshold",
    TEAM_CUMULATED_OVERTIME_THRESHOLD: "Overtime balance threshold",
    EMPLOYEE_ACCEPTED_OVERTIME_THRESHOLD: "Accepted overtime threshold",
    EMPLOYEE_REPORTED_OVERTIME_THRESHOLD: "Reported overtime threshold",
    EMPLOYEE_CUMULATED_OVERTIME_THRESHOLD: "Overtime balance threshold",
    SEND_AT_MONTH_DAY: "Send a report on every",
    SEND_AT: "Send at",
    EVERY_DAY: "calendar day of the month",
    LANGUAGE: "Language",
    TEAM: "Team",
    EDIT: "Edit",
    DELETE: "Delete",
    SEND_SUBSCRIPTION: "Send subscription",
    TEAM_ROWS: "Max rows",
    EMPLOYEE_ROWS: "Max rows"
  },
  OVERTIME_APPLICATION: {
    OVERTIME_APPLICATION: "Overtime request",
    CONFIRM_DELETE: "Are you sure you want to delete request number",
    CONFIRM_ACCEPT: "Are you sure you want to accept request number",
    YES: "Yes",
    APPLICATIONS_WAITING_FOR_ACCEPTANCE: "Requests waiting for acceptance",
    ACCEPTED_APPLICATIONS: "Accepted requests",
    REQUESTED_CHANGES: "Requested changes",
    STARTED_APPLICATIONS: "Started requests",
    FINISHED_AND_REJECTED_APPLICATIONS: "Processed and rejected requests",
    SETTLED_APPLICATIONS: "Finished requests",
    SETTLE_REQUEST: "Settle request",
    POSSIBLE_TIME: "Possible time to settle",
    USE_ALL: "Use all time",
    POSSIBLE_TIME_IS_SMALLER: "Possible time is smaller than time to settle",
    TIME_TO_SETTLE_TOO_SMALL: "Time to settle is too small",
    TABLE: {
      FROM: "From",
      TO: "To",
      NEW_APPLICATION: "Add new request",
      APPLICATION_CODE: "Request code",
      CLIENTS: "Client(s)",
      DURATION: "Duration",
      REPORTED_TIME: "Reported time",
      LAST_COMMENT: "Last comment",
      STATUS: "Status",
      VIEW: "View",
      ACCEPT: "Accept",
      EDIT: "Edit",
      REQUEST_CHANGES: "Request changes",
      ALLOCATE: "Allocate",
      SETTLE: "Settle",
      NO_APPLICATIONS: "No requests",
      EMPLOYEE: "Employee",
      COMPLETED_NEGATIVELY_TOOLTIP: "No worklog has been added with this overtime request",
      REJECT: "Reject",
      SETTLE_TOOLTIP: "To settle this request, you need to contact the Team Leader or Manager",
      NO_EMPLOYEES: "No employees to choose from"
    },
    FORM: {
      NEW_APPLICATION: "New request",
      FROM: "From",
      FROM_ERROR: 'Value "From" is not valid. First available date is ',
      TO: "To",
      TO_ERROR: 'Value "To" must not start before "From" value',
      DURATION: "Duration",
      FOR_EMPLOYEE: "For employee",
      APPROVERS: "Approver(s)",
      CLIENTS: "Client(s)",
      COMMENT: "Comment",
      COMMENTS_HISTORY: "Comments history:",
      REQUEST_CHANGES: "Request changes",
      SEND: "Send"
    },
    STATUS_TYPES: {
      NEW: "New",
      SENT: "Sent",
      TO_ACCEPT: "To accept",
      ACCEPTED: "Accepted",
      UPDATE_DONE: "Update done",
      REQUESTED_UPDATE: "Update requested",
      NEW_UPDATE: "New update",
      COMPLETED_PARTIALLY: "Processed partially",
      COMPLETED_POSITIVELY: "Processed positively",
      COMPLETED_NEGATIVELY: "Processed negatively",
      ALLOCATED_PARTIALLY: "Allocated Partially",
      ALLOCATED: "Allocated",
      SETTLED: "Settled",
      SETTLED_PARTIALLY: "Settled partially",
      REJECTED: "Rejected"
    },
    LAST_UPDATE_ERROR: "This overime request has been updated in the meantime. Refresh the page and see what has changed in it."
  },
  LEGAL_RULES: {
    TITLE: "Legal rules",
    NEW: "Add new legal configuration",
    LEGAL_OVERTIME_RULES: "Legal overtime rules",
    MON: "Mon",
    TUE: "Tue",
    WED: "Wed",
    THU: "Thu",
    FRI: "Fri",
    SAT: "Sat",
    SUN: "Sun",
    HOLIDAY_THRESHOLD: "Holiday",
    SUBSCRIPTION_USERS: "Addressee",
    VALID_FROM: "Valid from",
    DELETE: "Delete",
    DELETE_LEGAL_OVERTIME_RULES: "Delete legal overtime rules",
    EDIT: "Edit",
    LEGAL_RULES_ALERT: "Legal rules alert",
    CONFIRM_ADDITION: "Do you want to add legal overtime alert for {{user}}?",
    LANGUAGE: "Language",
    CONFIRM_CHANGE_LANGUAGE: "Do you want to change legal overtime alert <b>language</b> for",
    DEFINE: "Define a work time limit for each day and holidays",
    DEFINE_TOOLTIP: "The indicated number of hours is the daily limit of the reported work time. The limit on each day may be different - alerts will be sent based on indicated number of hours. If users should not work on specific day please write in “0” in the gap.",
    SUBSCRIPTIONUSERS_TOOLTIP: " Please select users to whom alerts about their employees will be sent."
  },
  USERSUBSANDALERTS: {
    TITLE: "Subscriptions and alerts",
    USER_NAME: "Full name",
    USER_TEAM_NAME: "Team name",
    ROLE: "Role",
    OVERTIME_SUBSCRIPTION: "Overtime subscription",
    PROFITABILITY_SUBSCRIPTION: "Profitability subscription",
    WORKTIME_SUBSCRIPTION: "Legal overtime alerts",
    VIEW: "View",
    ADD: "Add new",
    OVERTIME_APPLICATION_SUBSCRIPTION: "Overtime request alerts"
  },
  SUBORDINATE_TEAMS: {
    TITLE: "Subordinate teams",
    NAME: "Team name",
    MAIN: "Main",
    ACTIVE: "Active",
    ACTIVATE: "Activate",
    DEACTIVATE: "Deactivate",
    ARCHIVED: "Archived"
  },
  NOTES: {
    TITLE: "Notes",
    CLIENT_NOTE: "Client set-up and organization information"
  },
  AUTOMATION_DASHBOARD: {
    TITLE: "Automation dashboard",
    AUTOMATION_NAME: "Technology",
    NEW: "Add new technology",
    EXPORT: "Export",
    HISTORIC_EXPORT: "Historic export",
    EDIT: "Edit",
    DELETE: "Delete",
    HISTORIC_EXPORT_CHANGES: "Historic changes export"
  },
  TECHNOLOGY: {
    NEW_TECHNOLOGY: "New technology",
    AUTOMATION_NAME: "Name",
    EDIT_TECHNOLOGY: "Edit technology",
    DELETE_TECHNOLOGY: "Delete technology",
    HISTORIC_EXPORT: "Historic export",
    HISTORIC_CHANGES_EXPORT: "Historic changes export",
    FROM: "Pick date from",
    TO: "to"
  },
  BILLING_TYPE: {
    TITLE: "Billing type",
    ADD_NEW: "Add new billing type",
    NEW_BILLING_TYPE: "New billing type",
    NAME: "Name",
    COUNTRY: "Country",
    BILLING_TYPE: "Billing type",
    EDIT: "Edit",
    DELETE: "Delete",
    EDIT_BILLING_TYPE: "Edit billing type",
    DELETE_BILLING_TYPE: "Delete billing type"
  },
  OVERTIME_REQUESTS_ALERT: {
    ADD_SUBSCRIPTION: "Add Overtime request alert",
    EDIT_SUBSCRIPTION: "Edit Overtime request alert",
    DELETE_SUBSCRIPTION: "Delete Overtime request alert",
    LANGUAGE: "Language",
    TEAM_ID: "Team",
    ALL_TEAMS: "All Teams"
  },
  D365: {
    D365: "D365",
    CLIENT_D365: "Client (D365)",
    TAX_ID_KLIX: "Tax ID (KliX)",
    CLIENT_KLIX: "Client (KliX)",
    CLIENTS_KLIX: "Clients in KliX",
    NO_CLIENTS: "There are no clients in this country",
    CLIENTS_CONFIG: "Clients",
    PG_CONFIG: "Processes",

    INTERRUPTS: "Interrupts",
    INTERRUPT_KLIX: "Interrupt (KliX)",
    D365_PROCESS_GROUP: "D365 Process Group",
    PROCESS_GROUPS: "Process Groups in KliX",
    PROCESS_GROUP_KLIX: "Process Group (KliX)",
    EXCEPTIONS: "Exceptions",
    ADD_EXCEPTION: "Add Exception",
    PROCESS_FOR_PG: "Process for Process Group",
    EDIT: "Edit",
    DELETE: "Delete",
    SELECT_PROCESS_GROUPS: "Select Process Group",
    SELECT_PROCESS: "Select Process",
    PROCESS: "Process",
    PROCESS_KLIX: "Process (KliX)",
    WBS_ELEMENT: "WBS-ELEMENT (D365)",
    PG_INACTIVE: "This process group is inactive in D365.",
    PROCESS_INACTIVE: "This process is inactive in D365.",
    CLIENT_SEARCH_PLACEHOLDER: "Type at least 3 characters to search automatically or press enter to force a search",
    CLIENT_SEARCH_TOOLTIP: "The shorter the string (or lack thereof) the search time can take up to several minutes",
    NO_INTERRUPTS_WITHOUT_CLIENT: "There are no Interrupts without client in this country",
    NO_INTERRUPTS_WITH_CLIENT: "There are no Interrupts with client in this country",
    INTERRUPTS_WITHOUT_CLIENT: "Interrupts without client",
    INTERRUPTS_WITH_CLIENT: "Interrupts with client",
    INTERRUPT_D365: "WBS-ELEMENT (D365)",
    INTERRUPT_SEARCH_PLACEHOLDER: "Type at least 3 characters to search automatically or press enter to force a search",
    INTERRUPT_SEARCH_TOOLTIP: "The shorter the string (or lack thereof) the search time can take up to several minutes",
  },
  PROFIT_CENTER: {
    TITLE: "Profit center",
    ADD_NEW_PROFIT_CENTER: "Add new profit center",
    NEW_PROFIT_CENTER: "New profit center",
    NAME: "Name",
    COUNTRY: "Country",
    EDIT: "Edit",
    DELETE: "Delete",
    EDIT_PROFIT_CENTER: "Edit profit center",
    DELETE_PROFIT_CENTER: "Delete profit center",
    SEARCH: "Search",
    CODE:"Code",
    DESCRIPTION:"Description"
  },
  SENIORITY_LEVELS: {
    TITLE: "Levels",
    EDIT_SENIORITY_LEVELS: "Edit levels",
    L01: "L01 - non-Fee-Earner",
    L02: "L02 - Associate",
    L03: "L03",
    L04: "L04 - Senior Associate",
    L05: "L05",
    L06: "L06 - Manager",
    L07: "L07",
    L08: "L08 - Associate Partner",
    L09: "L09",
    L10: "L10 - Partner / Equity Partner / Shareholder"
  },
  REPORTS: {
    TITLE: "Reports",
    ADD: "Add new report",
    NEW_REPORT: "New report",
    REPORT: "Type",
    NAME: "Name",
    REPORT_COUNTRIES: "Countries",
    SEND_AT_MONTH_DAY: "Send a report on every",
    EVERY_DAY: "day of the month",
    LANGUAGE: "Language",
    SEND_FREQUENCY: "Frequency",
    REPORT_DETAILS: "Report details",
    ROLE: "Role",
    TEAM: "Team",
    SITE: "Site",
    PROFIT_CENTER: "Profit center",
    ACTIVE_FROM: "Active from",
    MONTHLY: "1 month",
    QUARTERLY: "3 months",
    YEARLY: "12 months",
    GROUPED_USERS: "Invoicing Report",
    USERS: "Users Report",
    EMAIL_ADDRESSES: "E-mails",
    USERS_NUMBER: "Amount of users",
    SEND_AT: "Send at",
    FREQUENCY: "Send frequency",
    COUNTRY: "Country",
    EMAILS: "E-mails",
    SEARCH: "Search",
    EDIT: "Edit",
    EDIT_REPORT: "Edit report",
    DELETE: "Delete",
    DELETE_REPORT: "Delete report",
    SEND_REPORT: "Send report",
    REPORT_TYPE: "Type",
    EXCLUDED_TEAMS: "Excluded Teams",
    EXCLUDED_TEAMS_INFO: "Excluded Teams"
  }
};
